webpackJsonp(["pages.projects.tree.show"],{

/***/ "../../../node_modules/dropzone/dist/dropzone.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery, module) {
/*
 *
 * More info at [www.dropzonejs.com](http://www.dropzonejs.com)
 *
 * Copyright (c) 2012, Matias Meno
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *
 */

(function() {
  var Dropzone, Emitter, camelize, contentLoaded, detectVerticalSquash, drawImageIOSFix, noop, without,
    __slice = [].slice,
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  noop = function() {};

  Emitter = (function() {
    function Emitter() {}

    Emitter.prototype.addEventListener = Emitter.prototype.on;

    Emitter.prototype.on = function(event, fn) {
      this._callbacks = this._callbacks || {};
      if (!this._callbacks[event]) {
        this._callbacks[event] = [];
      }
      this._callbacks[event].push(fn);
      return this;
    };

    Emitter.prototype.emit = function() {
      var args, callback, callbacks, event, _i, _len;
      event = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
      this._callbacks = this._callbacks || {};
      callbacks = this._callbacks[event];
      if (callbacks) {
        for (_i = 0, _len = callbacks.length; _i < _len; _i++) {
          callback = callbacks[_i];
          callback.apply(this, args);
        }
      }
      return this;
    };

    Emitter.prototype.removeListener = Emitter.prototype.off;

    Emitter.prototype.removeAllListeners = Emitter.prototype.off;

    Emitter.prototype.removeEventListener = Emitter.prototype.off;

    Emitter.prototype.off = function(event, fn) {
      var callback, callbacks, i, _i, _len;
      if (!this._callbacks || arguments.length === 0) {
        this._callbacks = {};
        return this;
      }
      callbacks = this._callbacks[event];
      if (!callbacks) {
        return this;
      }
      if (arguments.length === 1) {
        delete this._callbacks[event];
        return this;
      }
      for (i = _i = 0, _len = callbacks.length; _i < _len; i = ++_i) {
        callback = callbacks[i];
        if (callback === fn) {
          callbacks.splice(i, 1);
          break;
        }
      }
      return this;
    };

    return Emitter;

  })();

  Dropzone = (function(_super) {
    var extend, resolveOption;

    __extends(Dropzone, _super);

    Dropzone.prototype.Emitter = Emitter;


    /*
    This is a list of all available events you can register on a dropzone object.
    
    You can register an event handler like this:
    
        dropzone.on("dragEnter", function() { });
     */

    Dropzone.prototype.events = ["drop", "dragstart", "dragend", "dragenter", "dragover", "dragleave", "addedfile", "addedfiles", "removedfile", "thumbnail", "error", "errormultiple", "processing", "processingmultiple", "uploadprogress", "totaluploadprogress", "sending", "sendingmultiple", "success", "successmultiple", "canceled", "canceledmultiple", "complete", "completemultiple", "reset", "maxfilesexceeded", "maxfilesreached", "queuecomplete"];

    Dropzone.prototype.defaultOptions = {
      url: null,
      method: "post",
      withCredentials: false,
      parallelUploads: 2,
      uploadMultiple: false,
      maxFilesize: 256,
      paramName: "file",
      createImageThumbnails: true,
      maxThumbnailFilesize: 10,
      thumbnailWidth: 120,
      thumbnailHeight: 120,
      filesizeBase: 1000,
      maxFiles: null,
      params: {},
      clickable: true,
      ignoreHiddenFiles: true,
      acceptedFiles: null,
      acceptedMimeTypes: null,
      autoProcessQueue: true,
      autoQueue: true,
      addRemoveLinks: false,
      previewsContainer: null,
      hiddenInputContainer: "body",
      capture: null,
      dictDefaultMessage: "Drop files here to upload",
      dictFallbackMessage: "Your browser does not support drag'n'drop file uploads.",
      dictFallbackText: "Please use the fallback form below to upload your files like in the olden days.",
      dictFileTooBig: "File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.",
      dictInvalidFileType: "You can't upload files of this type.",
      dictResponseError: "Server responded with {{statusCode}} code.",
      dictCancelUpload: "Cancel upload",
      dictCancelUploadConfirmation: "Are you sure you want to cancel this upload?",
      dictRemoveFile: "Remove file",
      dictRemoveFileConfirmation: null,
      dictMaxFilesExceeded: "You can not upload any more files.",
      accept: function(file, done) {
        return done();
      },
      init: function() {
        return noop;
      },
      forceFallback: false,
      fallback: function() {
        var child, messageElement, span, _i, _len, _ref;
        this.element.className = "" + this.element.className + " dz-browser-not-supported";
        _ref = this.element.getElementsByTagName("div");
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          child = _ref[_i];
          if (/(^| )dz-message($| )/.test(child.className)) {
            messageElement = child;
            child.className = "dz-message";
            continue;
          }
        }
        if (!messageElement) {
          messageElement = Dropzone.createElement("<div class=\"dz-message\"><span></span></div>");
          this.element.appendChild(messageElement);
        }
        span = messageElement.getElementsByTagName("span")[0];
        if (span) {
          if (span.textContent != null) {
            span.textContent = this.options.dictFallbackMessage;
          } else if (span.innerText != null) {
            span.innerText = this.options.dictFallbackMessage;
          }
        }
        return this.element.appendChild(this.getFallbackForm());
      },
      resize: function(file) {
        var info, srcRatio, trgRatio;
        info = {
          srcX: 0,
          srcY: 0,
          srcWidth: file.width,
          srcHeight: file.height
        };
        srcRatio = file.width / file.height;
        info.optWidth = this.options.thumbnailWidth;
        info.optHeight = this.options.thumbnailHeight;
        if ((info.optWidth == null) && (info.optHeight == null)) {
          info.optWidth = info.srcWidth;
          info.optHeight = info.srcHeight;
        } else if (info.optWidth == null) {
          info.optWidth = srcRatio * info.optHeight;
        } else if (info.optHeight == null) {
          info.optHeight = (1 / srcRatio) * info.optWidth;
        }
        trgRatio = info.optWidth / info.optHeight;
        if (file.height < info.optHeight || file.width < info.optWidth) {
          info.trgHeight = info.srcHeight;
          info.trgWidth = info.srcWidth;
        } else {
          if (srcRatio > trgRatio) {
            info.srcHeight = file.height;
            info.srcWidth = info.srcHeight * trgRatio;
          } else {
            info.srcWidth = file.width;
            info.srcHeight = info.srcWidth / trgRatio;
          }
        }
        info.srcX = (file.width - info.srcWidth) / 2;
        info.srcY = (file.height - info.srcHeight) / 2;
        return info;
      },

      /*
      Those functions register themselves to the events on init and handle all
      the user interface specific stuff. Overwriting them won't break the upload
      but can break the way it's displayed.
      You can overwrite them if you don't like the default behavior. If you just
      want to add an additional event handler, register it on the dropzone object
      and don't overwrite those options.
       */
      drop: function(e) {
        return this.element.classList.remove("dz-drag-hover");
      },
      dragstart: noop,
      dragend: function(e) {
        return this.element.classList.remove("dz-drag-hover");
      },
      dragenter: function(e) {
        return this.element.classList.add("dz-drag-hover");
      },
      dragover: function(e) {
        return this.element.classList.add("dz-drag-hover");
      },
      dragleave: function(e) {
        return this.element.classList.remove("dz-drag-hover");
      },
      paste: noop,
      reset: function() {
        return this.element.classList.remove("dz-started");
      },
      addedfile: function(file) {
        var node, removeFileEvent, removeLink, _i, _j, _k, _len, _len1, _len2, _ref, _ref1, _ref2, _results;
        if (this.element === this.previewsContainer) {
          this.element.classList.add("dz-started");
        }
        if (this.previewsContainer) {
          file.previewElement = Dropzone.createElement(this.options.previewTemplate.trim());
          file.previewTemplate = file.previewElement;
          this.previewsContainer.appendChild(file.previewElement);
          _ref = file.previewElement.querySelectorAll("[data-dz-name]");
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            node = _ref[_i];
            node.textContent = file.name;
          }
          _ref1 = file.previewElement.querySelectorAll("[data-dz-size]");
          for (_j = 0, _len1 = _ref1.length; _j < _len1; _j++) {
            node = _ref1[_j];
            node.innerHTML = this.filesize(file.size);
          }
          if (this.options.addRemoveLinks) {
            file._removeLink = Dropzone.createElement("<a class=\"dz-remove\" href=\"javascript:undefined;\" data-dz-remove>" + this.options.dictRemoveFile + "</a>");
            file.previewElement.appendChild(file._removeLink);
          }
          removeFileEvent = (function(_this) {
            return function(e) {
              e.preventDefault();
              e.stopPropagation();
              if (file.status === Dropzone.UPLOADING) {
                return Dropzone.confirm(_this.options.dictCancelUploadConfirmation, function() {
                  return _this.removeFile(file);
                });
              } else {
                if (_this.options.dictRemoveFileConfirmation) {
                  return Dropzone.confirm(_this.options.dictRemoveFileConfirmation, function() {
                    return _this.removeFile(file);
                  });
                } else {
                  return _this.removeFile(file);
                }
              }
            };
          })(this);
          _ref2 = file.previewElement.querySelectorAll("[data-dz-remove]");
          _results = [];
          for (_k = 0, _len2 = _ref2.length; _k < _len2; _k++) {
            removeLink = _ref2[_k];
            _results.push(removeLink.addEventListener("click", removeFileEvent));
          }
          return _results;
        }
      },
      removedfile: function(file) {
        var _ref;
        if (file.previewElement) {
          if ((_ref = file.previewElement) != null) {
            _ref.parentNode.removeChild(file.previewElement);
          }
        }
        return this._updateMaxFilesReachedClass();
      },
      thumbnail: function(file, dataUrl) {
        var thumbnailElement, _i, _len, _ref;
        if (file.previewElement) {
          file.previewElement.classList.remove("dz-file-preview");
          _ref = file.previewElement.querySelectorAll("[data-dz-thumbnail]");
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            thumbnailElement = _ref[_i];
            thumbnailElement.alt = file.name;
            thumbnailElement.src = dataUrl;
          }
          return setTimeout(((function(_this) {
            return function() {
              return file.previewElement.classList.add("dz-image-preview");
            };
          })(this)), 1);
        }
      },
      error: function(file, message) {
        var node, _i, _len, _ref, _results;
        if (file.previewElement) {
          file.previewElement.classList.add("dz-error");
          if (typeof message !== "String" && message.error) {
            message = message.error;
          }
          _ref = file.previewElement.querySelectorAll("[data-dz-errormessage]");
          _results = [];
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            node = _ref[_i];
            _results.push(node.textContent = message);
          }
          return _results;
        }
      },
      errormultiple: noop,
      processing: function(file) {
        if (file.previewElement) {
          file.previewElement.classList.add("dz-processing");
          if (file._removeLink) {
            return file._removeLink.textContent = this.options.dictCancelUpload;
          }
        }
      },
      processingmultiple: noop,
      uploadprogress: function(file, progress, bytesSent) {
        var node, _i, _len, _ref, _results;
        if (file.previewElement) {
          _ref = file.previewElement.querySelectorAll("[data-dz-uploadprogress]");
          _results = [];
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            node = _ref[_i];
            if (node.nodeName === 'PROGRESS') {
              _results.push(node.value = progress);
            } else {
              _results.push(node.style.width = "" + progress + "%");
            }
          }
          return _results;
        }
      },
      totaluploadprogress: noop,
      sending: noop,
      sendingmultiple: noop,
      success: function(file) {
        if (file.previewElement) {
          return file.previewElement.classList.add("dz-success");
        }
      },
      successmultiple: noop,
      canceled: function(file) {
        return this.emit("error", file, "Upload canceled.");
      },
      canceledmultiple: noop,
      complete: function(file) {
        if (file._removeLink) {
          file._removeLink.textContent = this.options.dictRemoveFile;
        }
        if (file.previewElement) {
          return file.previewElement.classList.add("dz-complete");
        }
      },
      completemultiple: noop,
      maxfilesexceeded: noop,
      maxfilesreached: noop,
      queuecomplete: noop,
      addedfiles: noop,
      previewTemplate: "<div class=\"dz-preview dz-file-preview\">\n  <div class=\"dz-image\"><img data-dz-thumbnail /></div>\n  <div class=\"dz-details\">\n    <div class=\"dz-size\"><span data-dz-size></span></div>\n    <div class=\"dz-filename\"><span data-dz-name></span></div>\n  </div>\n  <div class=\"dz-progress\"><span class=\"dz-upload\" data-dz-uploadprogress></span></div>\n  <div class=\"dz-error-message\"><span data-dz-errormessage></span></div>\n  <div class=\"dz-success-mark\">\n    <svg width=\"54px\" height=\"54px\" viewBox=\"0 0 54 54\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\">\n      <title>Check</title>\n      <defs></defs>\n      <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\">\n        <path d=\"M23.5,31.8431458 L17.5852419,25.9283877 C16.0248253,24.3679711 13.4910294,24.366835 11.9289322,25.9289322 C10.3700136,27.4878508 10.3665912,30.0234455 11.9283877,31.5852419 L20.4147581,40.0716123 C20.5133999,40.1702541 20.6159315,40.2626649 20.7218615,40.3488435 C22.2835669,41.8725651 24.794234,41.8626202 26.3461564,40.3106978 L43.3106978,23.3461564 C44.8771021,21.7797521 44.8758057,19.2483887 43.3137085,17.6862915 C41.7547899,16.1273729 39.2176035,16.1255422 37.6538436,17.6893022 L23.5,31.8431458 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z\" id=\"Oval-2\" stroke-opacity=\"0.198794158\" stroke=\"#747474\" fill-opacity=\"0.816519475\" fill=\"#FFFFFF\" sketch:type=\"MSShapeGroup\"></path>\n      </g>\n    </svg>\n  </div>\n  <div class=\"dz-error-mark\">\n    <svg width=\"54px\" height=\"54px\" viewBox=\"0 0 54 54\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\">\n      <title>Error</title>\n      <defs></defs>\n      <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\">\n        <g id=\"Check-+-Oval-2\" sketch:type=\"MSLayerGroup\" stroke=\"#747474\" stroke-opacity=\"0.198794158\" fill=\"#FFFFFF\" fill-opacity=\"0.816519475\">\n          <path d=\"M32.6568542,29 L38.3106978,23.3461564 C39.8771021,21.7797521 39.8758057,19.2483887 38.3137085,17.6862915 C36.7547899,16.1273729 34.2176035,16.1255422 32.6538436,17.6893022 L27,23.3431458 L21.3461564,17.6893022 C19.7823965,16.1255422 17.2452101,16.1273729 15.6862915,17.6862915 C14.1241943,19.2483887 14.1228979,21.7797521 15.6893022,23.3461564 L21.3431458,29 L15.6893022,34.6538436 C14.1228979,36.2202479 14.1241943,38.7516113 15.6862915,40.3137085 C17.2452101,41.8726271 19.7823965,41.8744578 21.3461564,40.3106978 L27,34.6568542 L32.6538436,40.3106978 C34.2176035,41.8744578 36.7547899,41.8726271 38.3137085,40.3137085 C39.8758057,38.7516113 39.8771021,36.2202479 38.3106978,34.6538436 L32.6568542,29 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z\" id=\"Oval-2\" sketch:type=\"MSShapeGroup\"></path>\n        </g>\n      </g>\n    </svg>\n  </div>\n</div>"
    };

    extend = function() {
      var key, object, objects, target, val, _i, _len;
      target = arguments[0], objects = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
      for (_i = 0, _len = objects.length; _i < _len; _i++) {
        object = objects[_i];
        for (key in object) {
          val = object[key];
          target[key] = val;
        }
      }
      return target;
    };

    function Dropzone(element, options) {
      var elementOptions, fallback, _ref;
      this.element = element;
      this.version = Dropzone.version;
      this.defaultOptions.previewTemplate = this.defaultOptions.previewTemplate.replace(/\n*/g, "");
      this.clickableElements = [];
      this.listeners = [];
      this.files = [];
      if (typeof this.element === "string") {
        this.element = document.querySelector(this.element);
      }
      if (!(this.element && (this.element.nodeType != null))) {
        throw new Error("Invalid dropzone element.");
      }
      if (this.element.dropzone) {
        throw new Error("Dropzone already attached.");
      }
      Dropzone.instances.push(this);
      this.element.dropzone = this;
      elementOptions = (_ref = Dropzone.optionsForElement(this.element)) != null ? _ref : {};
      this.options = extend({}, this.defaultOptions, elementOptions, options != null ? options : {});
      if (this.options.forceFallback || !Dropzone.isBrowserSupported()) {
        return this.options.fallback.call(this);
      }
      if (this.options.url == null) {
        this.options.url = this.element.getAttribute("action");
      }
      if (!this.options.url) {
        throw new Error("No URL provided.");
      }
      if (this.options.acceptedFiles && this.options.acceptedMimeTypes) {
        throw new Error("You can't provide both 'acceptedFiles' and 'acceptedMimeTypes'. 'acceptedMimeTypes' is deprecated.");
      }
      if (this.options.acceptedMimeTypes) {
        this.options.acceptedFiles = this.options.acceptedMimeTypes;
        delete this.options.acceptedMimeTypes;
      }
      this.options.method = this.options.method.toUpperCase();
      if ((fallback = this.getExistingFallback()) && fallback.parentNode) {
        fallback.parentNode.removeChild(fallback);
      }
      if (this.options.previewsContainer !== false) {
        if (this.options.previewsContainer) {
          this.previewsContainer = Dropzone.getElement(this.options.previewsContainer, "previewsContainer");
        } else {
          this.previewsContainer = this.element;
        }
      }
      if (this.options.clickable) {
        if (this.options.clickable === true) {
          this.clickableElements = [this.element];
        } else {
          this.clickableElements = Dropzone.getElements(this.options.clickable, "clickable");
        }
      }
      this.init();
    }

    Dropzone.prototype.getAcceptedFiles = function() {
      var file, _i, _len, _ref, _results;
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (file.accepted) {
          _results.push(file);
        }
      }
      return _results;
    };

    Dropzone.prototype.getRejectedFiles = function() {
      var file, _i, _len, _ref, _results;
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (!file.accepted) {
          _results.push(file);
        }
      }
      return _results;
    };

    Dropzone.prototype.getFilesWithStatus = function(status) {
      var file, _i, _len, _ref, _results;
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (file.status === status) {
          _results.push(file);
        }
      }
      return _results;
    };

    Dropzone.prototype.getQueuedFiles = function() {
      return this.getFilesWithStatus(Dropzone.QUEUED);
    };

    Dropzone.prototype.getUploadingFiles = function() {
      return this.getFilesWithStatus(Dropzone.UPLOADING);
    };

    Dropzone.prototype.getAddedFiles = function() {
      return this.getFilesWithStatus(Dropzone.ADDED);
    };

    Dropzone.prototype.getActiveFiles = function() {
      var file, _i, _len, _ref, _results;
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (file.status === Dropzone.UPLOADING || file.status === Dropzone.QUEUED) {
          _results.push(file);
        }
      }
      return _results;
    };

    Dropzone.prototype.init = function() {
      var eventName, noPropagation, setupHiddenFileInput, _i, _len, _ref, _ref1;
      if (this.element.tagName === "form") {
        this.element.setAttribute("enctype", "multipart/form-data");
      }
      if (this.element.classList.contains("dropzone") && !this.element.querySelector(".dz-message")) {
        this.element.appendChild(Dropzone.createElement("<div class=\"dz-default dz-message\"><span>" + this.options.dictDefaultMessage + "</span></div>"));
      }
      if (this.clickableElements.length) {
        setupHiddenFileInput = (function(_this) {
          return function() {
            if (_this.hiddenFileInput) {
              _this.hiddenFileInput.parentNode.removeChild(_this.hiddenFileInput);
            }
            _this.hiddenFileInput = document.createElement("input");
            _this.hiddenFileInput.setAttribute("type", "file");
            if ((_this.options.maxFiles == null) || _this.options.maxFiles > 1) {
              _this.hiddenFileInput.setAttribute("multiple", "multiple");
            }
            _this.hiddenFileInput.className = "dz-hidden-input";
            if (_this.options.acceptedFiles != null) {
              _this.hiddenFileInput.setAttribute("accept", _this.options.acceptedFiles);
            }
            if (_this.options.capture != null) {
              _this.hiddenFileInput.setAttribute("capture", _this.options.capture);
            }
            _this.hiddenFileInput.style.visibility = "hidden";
            _this.hiddenFileInput.style.position = "absolute";
            _this.hiddenFileInput.style.top = "0";
            _this.hiddenFileInput.style.left = "0";
            _this.hiddenFileInput.style.height = "0";
            _this.hiddenFileInput.style.width = "0";
            document.querySelector(_this.options.hiddenInputContainer).appendChild(_this.hiddenFileInput);
            return _this.hiddenFileInput.addEventListener("change", function() {
              var file, files, _i, _len;
              files = _this.hiddenFileInput.files;
              if (files.length) {
                for (_i = 0, _len = files.length; _i < _len; _i++) {
                  file = files[_i];
                  _this.addFile(file);
                }
              }
              _this.emit("addedfiles", files);
              return setupHiddenFileInput();
            });
          };
        })(this);
        setupHiddenFileInput();
      }
      this.URL = (_ref = window.URL) != null ? _ref : window.webkitURL;
      _ref1 = this.events;
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        eventName = _ref1[_i];
        this.on(eventName, this.options[eventName]);
      }
      this.on("uploadprogress", (function(_this) {
        return function() {
          return _this.updateTotalUploadProgress();
        };
      })(this));
      this.on("removedfile", (function(_this) {
        return function() {
          return _this.updateTotalUploadProgress();
        };
      })(this));
      this.on("canceled", (function(_this) {
        return function(file) {
          return _this.emit("complete", file);
        };
      })(this));
      this.on("complete", (function(_this) {
        return function(file) {
          if (_this.getAddedFiles().length === 0 && _this.getUploadingFiles().length === 0 && _this.getQueuedFiles().length === 0) {
            return setTimeout((function() {
              return _this.emit("queuecomplete");
            }), 0);
          }
        };
      })(this));
      noPropagation = function(e) {
        e.stopPropagation();
        if (e.preventDefault) {
          return e.preventDefault();
        } else {
          return e.returnValue = false;
        }
      };
      this.listeners = [
        {
          element: this.element,
          events: {
            "dragstart": (function(_this) {
              return function(e) {
                return _this.emit("dragstart", e);
              };
            })(this),
            "dragenter": (function(_this) {
              return function(e) {
                noPropagation(e);
                return _this.emit("dragenter", e);
              };
            })(this),
            "dragover": (function(_this) {
              return function(e) {
                var efct;
                try {
                  efct = e.dataTransfer.effectAllowed;
                } catch (_error) {}
                e.dataTransfer.dropEffect = 'move' === efct || 'linkMove' === efct ? 'move' : 'copy';
                noPropagation(e);
                return _this.emit("dragover", e);
              };
            })(this),
            "dragleave": (function(_this) {
              return function(e) {
                return _this.emit("dragleave", e);
              };
            })(this),
            "drop": (function(_this) {
              return function(e) {
                noPropagation(e);
                return _this.drop(e);
              };
            })(this),
            "dragend": (function(_this) {
              return function(e) {
                return _this.emit("dragend", e);
              };
            })(this)
          }
        }
      ];
      this.clickableElements.forEach((function(_this) {
        return function(clickableElement) {
          return _this.listeners.push({
            element: clickableElement,
            events: {
              "click": function(evt) {
                if ((clickableElement !== _this.element) || (evt.target === _this.element || Dropzone.elementInside(evt.target, _this.element.querySelector(".dz-message")))) {
                  _this.hiddenFileInput.click();
                }
                return true;
              }
            }
          });
        };
      })(this));
      this.enable();
      return this.options.init.call(this);
    };

    Dropzone.prototype.destroy = function() {
      var _ref;
      this.disable();
      this.removeAllFiles(true);
      if ((_ref = this.hiddenFileInput) != null ? _ref.parentNode : void 0) {
        this.hiddenFileInput.parentNode.removeChild(this.hiddenFileInput);
        this.hiddenFileInput = null;
      }
      delete this.element.dropzone;
      return Dropzone.instances.splice(Dropzone.instances.indexOf(this), 1);
    };

    Dropzone.prototype.updateTotalUploadProgress = function() {
      var activeFiles, file, totalBytes, totalBytesSent, totalUploadProgress, _i, _len, _ref;
      totalBytesSent = 0;
      totalBytes = 0;
      activeFiles = this.getActiveFiles();
      if (activeFiles.length) {
        _ref = this.getActiveFiles();
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          file = _ref[_i];
          totalBytesSent += file.upload.bytesSent;
          totalBytes += file.upload.total;
        }
        totalUploadProgress = 100 * totalBytesSent / totalBytes;
      } else {
        totalUploadProgress = 100;
      }
      return this.emit("totaluploadprogress", totalUploadProgress, totalBytes, totalBytesSent);
    };

    Dropzone.prototype._getParamName = function(n) {
      if (typeof this.options.paramName === "function") {
        return this.options.paramName(n);
      } else {
        return "" + this.options.paramName + (this.options.uploadMultiple ? "[" + n + "]" : "");
      }
    };

    Dropzone.prototype.getFallbackForm = function() {
      var existingFallback, fields, fieldsString, form;
      if (existingFallback = this.getExistingFallback()) {
        return existingFallback;
      }
      fieldsString = "<div class=\"dz-fallback\">";
      if (this.options.dictFallbackText) {
        fieldsString += "<p>" + this.options.dictFallbackText + "</p>";
      }
      fieldsString += "<input type=\"file\" name=\"" + (this._getParamName(0)) + "\" " + (this.options.uploadMultiple ? 'multiple="multiple"' : void 0) + " /><input type=\"submit\" value=\"Upload!\"></div>";
      fields = Dropzone.createElement(fieldsString);
      if (this.element.tagName !== "FORM") {
        form = Dropzone.createElement("<form action=\"" + this.options.url + "\" enctype=\"multipart/form-data\" method=\"" + this.options.method + "\"></form>");
        form.appendChild(fields);
      } else {
        this.element.setAttribute("enctype", "multipart/form-data");
        this.element.setAttribute("method", this.options.method);
      }
      return form != null ? form : fields;
    };

    Dropzone.prototype.getExistingFallback = function() {
      var fallback, getFallback, tagName, _i, _len, _ref;
      getFallback = function(elements) {
        var el, _i, _len;
        for (_i = 0, _len = elements.length; _i < _len; _i++) {
          el = elements[_i];
          if (/(^| )fallback($| )/.test(el.className)) {
            return el;
          }
        }
      };
      _ref = ["div", "form"];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        tagName = _ref[_i];
        if (fallback = getFallback(this.element.getElementsByTagName(tagName))) {
          return fallback;
        }
      }
    };

    Dropzone.prototype.setupEventListeners = function() {
      var elementListeners, event, listener, _i, _len, _ref, _results;
      _ref = this.listeners;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        elementListeners = _ref[_i];
        _results.push((function() {
          var _ref1, _results1;
          _ref1 = elementListeners.events;
          _results1 = [];
          for (event in _ref1) {
            listener = _ref1[event];
            _results1.push(elementListeners.element.addEventListener(event, listener, false));
          }
          return _results1;
        })());
      }
      return _results;
    };

    Dropzone.prototype.removeEventListeners = function() {
      var elementListeners, event, listener, _i, _len, _ref, _results;
      _ref = this.listeners;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        elementListeners = _ref[_i];
        _results.push((function() {
          var _ref1, _results1;
          _ref1 = elementListeners.events;
          _results1 = [];
          for (event in _ref1) {
            listener = _ref1[event];
            _results1.push(elementListeners.element.removeEventListener(event, listener, false));
          }
          return _results1;
        })());
      }
      return _results;
    };

    Dropzone.prototype.disable = function() {
      var file, _i, _len, _ref, _results;
      this.clickableElements.forEach(function(element) {
        return element.classList.remove("dz-clickable");
      });
      this.removeEventListeners();
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        _results.push(this.cancelUpload(file));
      }
      return _results;
    };

    Dropzone.prototype.enable = function() {
      this.clickableElements.forEach(function(element) {
        return element.classList.add("dz-clickable");
      });
      return this.setupEventListeners();
    };

    Dropzone.prototype.filesize = function(size) {
      var cutoff, i, selectedSize, selectedUnit, unit, units, _i, _len;
      selectedSize = 0;
      selectedUnit = "b";
      if (size > 0) {
        units = ['TB', 'GB', 'MB', 'KB', 'b'];
        for (i = _i = 0, _len = units.length; _i < _len; i = ++_i) {
          unit = units[i];
          cutoff = Math.pow(this.options.filesizeBase, 4 - i) / 10;
          if (size >= cutoff) {
            selectedSize = size / Math.pow(this.options.filesizeBase, 4 - i);
            selectedUnit = unit;
            break;
          }
        }
        selectedSize = Math.round(10 * selectedSize) / 10;
      }
      return "<strong>" + selectedSize + "</strong> " + selectedUnit;
    };

    Dropzone.prototype._updateMaxFilesReachedClass = function() {
      if ((this.options.maxFiles != null) && this.getAcceptedFiles().length >= this.options.maxFiles) {
        if (this.getAcceptedFiles().length === this.options.maxFiles) {
          this.emit('maxfilesreached', this.files);
        }
        return this.element.classList.add("dz-max-files-reached");
      } else {
        return this.element.classList.remove("dz-max-files-reached");
      }
    };

    Dropzone.prototype.drop = function(e) {
      var files, items;
      if (!e.dataTransfer) {
        return;
      }
      this.emit("drop", e);
      files = e.dataTransfer.files;
      this.emit("addedfiles", files);
      if (files.length) {
        items = e.dataTransfer.items;
        if (items && items.length && (items[0].webkitGetAsEntry != null)) {
          this._addFilesFromItems(items);
        } else {
          this.handleFiles(files);
        }
      }
    };

    Dropzone.prototype.paste = function(e) {
      var items, _ref;
      if ((e != null ? (_ref = e.clipboardData) != null ? _ref.items : void 0 : void 0) == null) {
        return;
      }
      this.emit("paste", e);
      items = e.clipboardData.items;
      if (items.length) {
        return this._addFilesFromItems(items);
      }
    };

    Dropzone.prototype.handleFiles = function(files) {
      var file, _i, _len, _results;
      _results = [];
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        _results.push(this.addFile(file));
      }
      return _results;
    };

    Dropzone.prototype._addFilesFromItems = function(items) {
      var entry, item, _i, _len, _results;
      _results = [];
      for (_i = 0, _len = items.length; _i < _len; _i++) {
        item = items[_i];
        if ((item.webkitGetAsEntry != null) && (entry = item.webkitGetAsEntry())) {
          if (entry.isFile) {
            _results.push(this.addFile(item.getAsFile()));
          } else if (entry.isDirectory) {
            _results.push(this._addFilesFromDirectory(entry, entry.name));
          } else {
            _results.push(void 0);
          }
        } else if (item.getAsFile != null) {
          if ((item.kind == null) || item.kind === "file") {
            _results.push(this.addFile(item.getAsFile()));
          } else {
            _results.push(void 0);
          }
        } else {
          _results.push(void 0);
        }
      }
      return _results;
    };

    Dropzone.prototype._addFilesFromDirectory = function(directory, path) {
      var dirReader, entriesReader;
      dirReader = directory.createReader();
      entriesReader = (function(_this) {
        return function(entries) {
          var entry, _i, _len;
          for (_i = 0, _len = entries.length; _i < _len; _i++) {
            entry = entries[_i];
            if (entry.isFile) {
              entry.file(function(file) {
                if (_this.options.ignoreHiddenFiles && file.name.substring(0, 1) === '.') {
                  return;
                }
                file.fullPath = "" + path + "/" + file.name;
                return _this.addFile(file);
              });
            } else if (entry.isDirectory) {
              _this._addFilesFromDirectory(entry, "" + path + "/" + entry.name);
            }
          }
        };
      })(this);
      return dirReader.readEntries(entriesReader, function(error) {
        return typeof console !== "undefined" && console !== null ? typeof console.log === "function" ? console.log(error) : void 0 : void 0;
      });
    };

    Dropzone.prototype.accept = function(file, done) {
      if (file.size > this.options.maxFilesize * 1024 * 1024) {
        return done(this.options.dictFileTooBig.replace("{{filesize}}", Math.round(file.size / 1024 / 10.24) / 100).replace("{{maxFilesize}}", this.options.maxFilesize));
      } else if (!Dropzone.isValidFile(file, this.options.acceptedFiles)) {
        return done(this.options.dictInvalidFileType);
      } else if ((this.options.maxFiles != null) && this.getAcceptedFiles().length >= this.options.maxFiles) {
        done(this.options.dictMaxFilesExceeded.replace("{{maxFiles}}", this.options.maxFiles));
        return this.emit("maxfilesexceeded", file);
      } else {
        return this.options.accept.call(this, file, done);
      }
    };

    Dropzone.prototype.addFile = function(file) {
      file.upload = {
        progress: 0,
        total: file.size,
        bytesSent: 0
      };
      this.files.push(file);
      file.status = Dropzone.ADDED;
      this.emit("addedfile", file);
      this._enqueueThumbnail(file);
      return this.accept(file, (function(_this) {
        return function(error) {
          if (error) {
            file.accepted = false;
            _this._errorProcessing([file], error);
          } else {
            file.accepted = true;
            if (_this.options.autoQueue) {
              _this.enqueueFile(file);
            }
          }
          return _this._updateMaxFilesReachedClass();
        };
      })(this));
    };

    Dropzone.prototype.enqueueFiles = function(files) {
      var file, _i, _len;
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        this.enqueueFile(file);
      }
      return null;
    };

    Dropzone.prototype.enqueueFile = function(file) {
      if (file.status === Dropzone.ADDED && file.accepted === true) {
        file.status = Dropzone.QUEUED;
        if (this.options.autoProcessQueue) {
          return setTimeout(((function(_this) {
            return function() {
              return _this.processQueue();
            };
          })(this)), 0);
        }
      } else {
        throw new Error("This file can't be queued because it has already been processed or was rejected.");
      }
    };

    Dropzone.prototype._thumbnailQueue = [];

    Dropzone.prototype._processingThumbnail = false;

    Dropzone.prototype._enqueueThumbnail = function(file) {
      if (this.options.createImageThumbnails && file.type.match(/image.*/) && file.size <= this.options.maxThumbnailFilesize * 1024 * 1024) {
        this._thumbnailQueue.push(file);
        return setTimeout(((function(_this) {
          return function() {
            return _this._processThumbnailQueue();
          };
        })(this)), 0);
      }
    };

    Dropzone.prototype._processThumbnailQueue = function() {
      if (this._processingThumbnail || this._thumbnailQueue.length === 0) {
        return;
      }
      this._processingThumbnail = true;
      return this.createThumbnail(this._thumbnailQueue.shift(), (function(_this) {
        return function() {
          _this._processingThumbnail = false;
          return _this._processThumbnailQueue();
        };
      })(this));
    };

    Dropzone.prototype.removeFile = function(file) {
      if (file.status === Dropzone.UPLOADING) {
        this.cancelUpload(file);
      }
      this.files = without(this.files, file);
      this.emit("removedfile", file);
      if (this.files.length === 0) {
        return this.emit("reset");
      }
    };

    Dropzone.prototype.removeAllFiles = function(cancelIfNecessary) {
      var file, _i, _len, _ref;
      if (cancelIfNecessary == null) {
        cancelIfNecessary = false;
      }
      _ref = this.files.slice();
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (file.status !== Dropzone.UPLOADING || cancelIfNecessary) {
          this.removeFile(file);
        }
      }
      return null;
    };

    Dropzone.prototype.createThumbnail = function(file, callback) {
      var fileReader;
      fileReader = new FileReader;
      fileReader.onload = (function(_this) {
        return function() {
          if (file.type === "image/svg+xml") {
            _this.emit("thumbnail", file, fileReader.result);
            if (callback != null) {
              callback();
            }
            return;
          }
          return _this.createThumbnailFromUrl(file, fileReader.result, callback);
        };
      })(this);
      return fileReader.readAsDataURL(file);
    };

    Dropzone.prototype.createThumbnailFromUrl = function(file, imageUrl, callback, crossOrigin) {
      var img;
      img = document.createElement("img");
      if (crossOrigin) {
        img.crossOrigin = crossOrigin;
      }
      img.onload = (function(_this) {
        return function() {
          var canvas, ctx, resizeInfo, thumbnail, _ref, _ref1, _ref2, _ref3;
          file.width = img.width;
          file.height = img.height;
          resizeInfo = _this.options.resize.call(_this, file);
          if (resizeInfo.trgWidth == null) {
            resizeInfo.trgWidth = resizeInfo.optWidth;
          }
          if (resizeInfo.trgHeight == null) {
            resizeInfo.trgHeight = resizeInfo.optHeight;
          }
          canvas = document.createElement("canvas");
          ctx = canvas.getContext("2d");
          canvas.width = resizeInfo.trgWidth;
          canvas.height = resizeInfo.trgHeight;
          drawImageIOSFix(ctx, img, (_ref = resizeInfo.srcX) != null ? _ref : 0, (_ref1 = resizeInfo.srcY) != null ? _ref1 : 0, resizeInfo.srcWidth, resizeInfo.srcHeight, (_ref2 = resizeInfo.trgX) != null ? _ref2 : 0, (_ref3 = resizeInfo.trgY) != null ? _ref3 : 0, resizeInfo.trgWidth, resizeInfo.trgHeight);
          thumbnail = canvas.toDataURL("image/png");
          _this.emit("thumbnail", file, thumbnail);
          if (callback != null) {
            return callback();
          }
        };
      })(this);
      if (callback != null) {
        img.onerror = callback;
      }
      return img.src = imageUrl;
    };

    Dropzone.prototype.processQueue = function() {
      var i, parallelUploads, processingLength, queuedFiles;
      parallelUploads = this.options.parallelUploads;
      processingLength = this.getUploadingFiles().length;
      i = processingLength;
      if (processingLength >= parallelUploads) {
        return;
      }
      queuedFiles = this.getQueuedFiles();
      if (!(queuedFiles.length > 0)) {
        return;
      }
      if (this.options.uploadMultiple) {
        return this.processFiles(queuedFiles.slice(0, parallelUploads - processingLength));
      } else {
        while (i < parallelUploads) {
          if (!queuedFiles.length) {
            return;
          }
          this.processFile(queuedFiles.shift());
          i++;
        }
      }
    };

    Dropzone.prototype.processFile = function(file) {
      return this.processFiles([file]);
    };

    Dropzone.prototype.processFiles = function(files) {
      var file, _i, _len;
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        file.processing = true;
        file.status = Dropzone.UPLOADING;
        this.emit("processing", file);
      }
      if (this.options.uploadMultiple) {
        this.emit("processingmultiple", files);
      }
      return this.uploadFiles(files);
    };

    Dropzone.prototype._getFilesWithXhr = function(xhr) {
      var file, files;
      return files = (function() {
        var _i, _len, _ref, _results;
        _ref = this.files;
        _results = [];
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          file = _ref[_i];
          if (file.xhr === xhr) {
            _results.push(file);
          }
        }
        return _results;
      }).call(this);
    };

    Dropzone.prototype.cancelUpload = function(file) {
      var groupedFile, groupedFiles, _i, _j, _len, _len1, _ref;
      if (file.status === Dropzone.UPLOADING) {
        groupedFiles = this._getFilesWithXhr(file.xhr);
        for (_i = 0, _len = groupedFiles.length; _i < _len; _i++) {
          groupedFile = groupedFiles[_i];
          groupedFile.status = Dropzone.CANCELED;
        }
        file.xhr.abort();
        for (_j = 0, _len1 = groupedFiles.length; _j < _len1; _j++) {
          groupedFile = groupedFiles[_j];
          this.emit("canceled", groupedFile);
        }
        if (this.options.uploadMultiple) {
          this.emit("canceledmultiple", groupedFiles);
        }
      } else if ((_ref = file.status) === Dropzone.ADDED || _ref === Dropzone.QUEUED) {
        file.status = Dropzone.CANCELED;
        this.emit("canceled", file);
        if (this.options.uploadMultiple) {
          this.emit("canceledmultiple", [file]);
        }
      }
      if (this.options.autoProcessQueue) {
        return this.processQueue();
      }
    };

    resolveOption = function() {
      var args, option;
      option = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
      if (typeof option === 'function') {
        return option.apply(this, args);
      }
      return option;
    };

    Dropzone.prototype.uploadFile = function(file) {
      return this.uploadFiles([file]);
    };

    Dropzone.prototype.uploadFiles = function(files) {
      var file, formData, handleError, headerName, headerValue, headers, i, input, inputName, inputType, key, method, option, progressObj, response, updateProgress, url, value, xhr, _i, _j, _k, _l, _len, _len1, _len2, _len3, _m, _ref, _ref1, _ref2, _ref3, _ref4, _ref5;
      xhr = new XMLHttpRequest();
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        file.xhr = xhr;
      }
      method = resolveOption(this.options.method, files);
      url = resolveOption(this.options.url, files);
      xhr.open(method, url, true);
      xhr.withCredentials = !!this.options.withCredentials;
      response = null;
      handleError = (function(_this) {
        return function() {
          var _j, _len1, _results;
          _results = [];
          for (_j = 0, _len1 = files.length; _j < _len1; _j++) {
            file = files[_j];
            _results.push(_this._errorProcessing(files, response || _this.options.dictResponseError.replace("{{statusCode}}", xhr.status), xhr));
          }
          return _results;
        };
      })(this);
      updateProgress = (function(_this) {
        return function(e) {
          var allFilesFinished, progress, _j, _k, _l, _len1, _len2, _len3, _results;
          if (e != null) {
            progress = 100 * e.loaded / e.total;
            for (_j = 0, _len1 = files.length; _j < _len1; _j++) {
              file = files[_j];
              file.upload = {
                progress: progress,
                total: e.total,
                bytesSent: e.loaded
              };
            }
          } else {
            allFilesFinished = true;
            progress = 100;
            for (_k = 0, _len2 = files.length; _k < _len2; _k++) {
              file = files[_k];
              if (!(file.upload.progress === 100 && file.upload.bytesSent === file.upload.total)) {
                allFilesFinished = false;
              }
              file.upload.progress = progress;
              file.upload.bytesSent = file.upload.total;
            }
            if (allFilesFinished) {
              return;
            }
          }
          _results = [];
          for (_l = 0, _len3 = files.length; _l < _len3; _l++) {
            file = files[_l];
            _results.push(_this.emit("uploadprogress", file, progress, file.upload.bytesSent));
          }
          return _results;
        };
      })(this);
      xhr.onload = (function(_this) {
        return function(e) {
          var _ref;
          if (files[0].status === Dropzone.CANCELED) {
            return;
          }
          if (xhr.readyState !== 4) {
            return;
          }
          response = xhr.responseText;
          if (xhr.getResponseHeader("content-type") && ~xhr.getResponseHeader("content-type").indexOf("application/json")) {
            try {
              response = JSON.parse(response);
            } catch (_error) {
              e = _error;
              response = "Invalid JSON response from server.";
            }
          }
          updateProgress();
          if (!((200 <= (_ref = xhr.status) && _ref < 300))) {
            return handleError();
          } else {
            return _this._finished(files, response, e);
          }
        };
      })(this);
      xhr.onerror = (function(_this) {
        return function() {
          if (files[0].status === Dropzone.CANCELED) {
            return;
          }
          return handleError();
        };
      })(this);
      progressObj = (_ref = xhr.upload) != null ? _ref : xhr;
      progressObj.onprogress = updateProgress;
      headers = {
        "Accept": "application/json",
        "Cache-Control": "no-cache",
        "X-Requested-With": "XMLHttpRequest"
      };
      if (this.options.headers) {
        extend(headers, this.options.headers);
      }
      for (headerName in headers) {
        headerValue = headers[headerName];
        if (headerValue) {
          xhr.setRequestHeader(headerName, headerValue);
        }
      }
      formData = new FormData();
      if (this.options.params) {
        _ref1 = this.options.params;
        for (key in _ref1) {
          value = _ref1[key];
          formData.append(key, value);
        }
      }
      for (_j = 0, _len1 = files.length; _j < _len1; _j++) {
        file = files[_j];
        this.emit("sending", file, xhr, formData);
      }
      if (this.options.uploadMultiple) {
        this.emit("sendingmultiple", files, xhr, formData);
      }
      if (this.element.tagName === "FORM") {
        _ref2 = this.element.querySelectorAll("input, textarea, select, button");
        for (_k = 0, _len2 = _ref2.length; _k < _len2; _k++) {
          input = _ref2[_k];
          inputName = input.getAttribute("name");
          inputType = input.getAttribute("type");
          if (input.tagName === "SELECT" && input.hasAttribute("multiple")) {
            _ref3 = input.options;
            for (_l = 0, _len3 = _ref3.length; _l < _len3; _l++) {
              option = _ref3[_l];
              if (option.selected) {
                formData.append(inputName, option.value);
              }
            }
          } else if (!inputType || ((_ref4 = inputType.toLowerCase()) !== "checkbox" && _ref4 !== "radio") || input.checked) {
            formData.append(inputName, input.value);
          }
        }
      }
      for (i = _m = 0, _ref5 = files.length - 1; 0 <= _ref5 ? _m <= _ref5 : _m >= _ref5; i = 0 <= _ref5 ? ++_m : --_m) {
        formData.append(this._getParamName(i), files[i], files[i].name);
      }
      return this.submitRequest(xhr, formData, files);
    };

    Dropzone.prototype.submitRequest = function(xhr, formData, files) {
      return xhr.send(formData);
    };

    Dropzone.prototype._finished = function(files, responseText, e) {
      var file, _i, _len;
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        file.status = Dropzone.SUCCESS;
        this.emit("success", file, responseText, e);
        this.emit("complete", file);
      }
      if (this.options.uploadMultiple) {
        this.emit("successmultiple", files, responseText, e);
        this.emit("completemultiple", files);
      }
      if (this.options.autoProcessQueue) {
        return this.processQueue();
      }
    };

    Dropzone.prototype._errorProcessing = function(files, message, xhr) {
      var file, _i, _len;
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        file.status = Dropzone.ERROR;
        this.emit("error", file, message, xhr);
        this.emit("complete", file);
      }
      if (this.options.uploadMultiple) {
        this.emit("errormultiple", files, message, xhr);
        this.emit("completemultiple", files);
      }
      if (this.options.autoProcessQueue) {
        return this.processQueue();
      }
    };

    return Dropzone;

  })(Emitter);

  Dropzone.version = "4.2.0";

  Dropzone.options = {};

  Dropzone.optionsForElement = function(element) {
    if (element.getAttribute("id")) {
      return Dropzone.options[camelize(element.getAttribute("id"))];
    } else {
      return void 0;
    }
  };

  Dropzone.instances = [];

  Dropzone.forElement = function(element) {
    if (typeof element === "string") {
      element = document.querySelector(element);
    }
    if ((element != null ? element.dropzone : void 0) == null) {
      throw new Error("No Dropzone found for given element. This is probably because you're trying to access it before Dropzone had the time to initialize. Use the `init` option to setup any additional observers on your Dropzone.");
    }
    return element.dropzone;
  };

  Dropzone.autoDiscover = true;

  Dropzone.discover = function() {
    var checkElements, dropzone, dropzones, _i, _len, _results;
    if (document.querySelectorAll) {
      dropzones = document.querySelectorAll(".dropzone");
    } else {
      dropzones = [];
      checkElements = function(elements) {
        var el, _i, _len, _results;
        _results = [];
        for (_i = 0, _len = elements.length; _i < _len; _i++) {
          el = elements[_i];
          if (/(^| )dropzone($| )/.test(el.className)) {
            _results.push(dropzones.push(el));
          } else {
            _results.push(void 0);
          }
        }
        return _results;
      };
      checkElements(document.getElementsByTagName("div"));
      checkElements(document.getElementsByTagName("form"));
    }
    _results = [];
    for (_i = 0, _len = dropzones.length; _i < _len; _i++) {
      dropzone = dropzones[_i];
      if (Dropzone.optionsForElement(dropzone) !== false) {
        _results.push(new Dropzone(dropzone));
      } else {
        _results.push(void 0);
      }
    }
    return _results;
  };

  Dropzone.blacklistedBrowsers = [/opera.*Macintosh.*version\/12/i];

  Dropzone.isBrowserSupported = function() {
    var capableBrowser, regex, _i, _len, _ref;
    capableBrowser = true;
    if (window.File && window.FileReader && window.FileList && window.Blob && window.FormData && document.querySelector) {
      if (!("classList" in document.createElement("a"))) {
        capableBrowser = false;
      } else {
        _ref = Dropzone.blacklistedBrowsers;
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          regex = _ref[_i];
          if (regex.test(navigator.userAgent)) {
            capableBrowser = false;
            continue;
          }
        }
      }
    } else {
      capableBrowser = false;
    }
    return capableBrowser;
  };

  without = function(list, rejectedItem) {
    var item, _i, _len, _results;
    _results = [];
    for (_i = 0, _len = list.length; _i < _len; _i++) {
      item = list[_i];
      if (item !== rejectedItem) {
        _results.push(item);
      }
    }
    return _results;
  };

  camelize = function(str) {
    return str.replace(/[\-_](\w)/g, function(match) {
      return match.charAt(1).toUpperCase();
    });
  };

  Dropzone.createElement = function(string) {
    var div;
    div = document.createElement("div");
    div.innerHTML = string;
    return div.childNodes[0];
  };

  Dropzone.elementInside = function(element, container) {
    if (element === container) {
      return true;
    }
    while (element = element.parentNode) {
      if (element === container) {
        return true;
      }
    }
    return false;
  };

  Dropzone.getElement = function(el, name) {
    var element;
    if (typeof el === "string") {
      element = document.querySelector(el);
    } else if (el.nodeType != null) {
      element = el;
    }
    if (element == null) {
      throw new Error("Invalid `" + name + "` option provided. Please provide a CSS selector or a plain HTML element.");
    }
    return element;
  };

  Dropzone.getElements = function(els, name) {
    var e, el, elements, _i, _j, _len, _len1, _ref;
    if (els instanceof Array) {
      elements = [];
      try {
        for (_i = 0, _len = els.length; _i < _len; _i++) {
          el = els[_i];
          elements.push(this.getElement(el, name));
        }
      } catch (_error) {
        e = _error;
        elements = null;
      }
    } else if (typeof els === "string") {
      elements = [];
      _ref = document.querySelectorAll(els);
      for (_j = 0, _len1 = _ref.length; _j < _len1; _j++) {
        el = _ref[_j];
        elements.push(el);
      }
    } else if (els.nodeType != null) {
      elements = [els];
    }
    if (!((elements != null) && elements.length)) {
      throw new Error("Invalid `" + name + "` option provided. Please provide a CSS selector, a plain HTML element or a list of those.");
    }
    return elements;
  };

  Dropzone.confirm = function(question, accepted, rejected) {
    if (window.confirm(question)) {
      return accepted();
    } else if (rejected != null) {
      return rejected();
    }
  };

  Dropzone.isValidFile = function(file, acceptedFiles) {
    var baseMimeType, mimeType, validType, _i, _len;
    if (!acceptedFiles) {
      return true;
    }
    acceptedFiles = acceptedFiles.split(",");
    mimeType = file.type;
    baseMimeType = mimeType.replace(/\/.*$/, "");
    for (_i = 0, _len = acceptedFiles.length; _i < _len; _i++) {
      validType = acceptedFiles[_i];
      validType = validType.trim();
      if (validType.charAt(0) === ".") {
        if (file.name.toLowerCase().indexOf(validType.toLowerCase(), file.name.length - validType.length) !== -1) {
          return true;
        }
      } else if (/\/\*$/.test(validType)) {
        if (baseMimeType === validType.replace(/\/.*$/, "")) {
          return true;
        }
      } else {
        if (mimeType === validType) {
          return true;
        }
      }
    }
    return false;
  };

  if (typeof jQuery !== "undefined" && jQuery !== null) {
    jQuery.fn.dropzone = function(options) {
      return this.each(function() {
        return new Dropzone(this, options);
      });
    };
  }

  if (typeof module !== "undefined" && module !== null) {
    module.exports = Dropzone;
  } else {
    window.Dropzone = Dropzone;
  }

  Dropzone.ADDED = "added";

  Dropzone.QUEUED = "queued";

  Dropzone.ACCEPTED = Dropzone.QUEUED;

  Dropzone.UPLOADING = "uploading";

  Dropzone.PROCESSING = Dropzone.UPLOADING;

  Dropzone.CANCELED = "canceled";

  Dropzone.ERROR = "error";

  Dropzone.SUCCESS = "success";


  /*
  
  Bugfix for iOS 6 and 7
  Source: http://stackoverflow.com/questions/11929099/html5-canvas-drawimage-ratio-bug-ios
  based on the work of https://github.com/stomita/ios-imagefile-megapixel
   */

  detectVerticalSquash = function(img) {
    var alpha, canvas, ctx, data, ey, ih, iw, py, ratio, sy;
    iw = img.naturalWidth;
    ih = img.naturalHeight;
    canvas = document.createElement("canvas");
    canvas.width = 1;
    canvas.height = ih;
    ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
    data = ctx.getImageData(0, 0, 1, ih).data;
    sy = 0;
    ey = ih;
    py = ih;
    while (py > sy) {
      alpha = data[(py - 1) * 4 + 3];
      if (alpha === 0) {
        ey = py;
      } else {
        sy = py;
      }
      py = (ey + sy) >> 1;
    }
    ratio = py / ih;
    if (ratio === 0) {
      return 1;
    } else {
      return ratio;
    }
  };

  drawImageIOSFix = function(ctx, img, sx, sy, sw, sh, dx, dy, dw, dh) {
    var vertSquashRatio;
    vertSquashRatio = detectVerticalSquash(img);
    return ctx.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh / vertSquashRatio);
  };


  /*
   * contentloaded.js
   *
   * Author: Diego Perini (diego.perini at gmail.com)
   * Summary: cross-browser wrapper for DOMContentLoaded
   * Updated: 20101020
   * License: MIT
   * Version: 1.2
   *
   * URL:
   * http://javascript.nwbox.com/ContentLoaded/
   * http://javascript.nwbox.com/ContentLoaded/MIT-LICENSE
   */

  contentLoaded = function(win, fn) {
    var add, doc, done, init, poll, pre, rem, root, top;
    done = false;
    top = true;
    doc = win.document;
    root = doc.documentElement;
    add = (doc.addEventListener ? "addEventListener" : "attachEvent");
    rem = (doc.addEventListener ? "removeEventListener" : "detachEvent");
    pre = (doc.addEventListener ? "" : "on");
    init = function(e) {
      if (e.type === "readystatechange" && doc.readyState !== "complete") {
        return;
      }
      (e.type === "load" ? win : doc)[rem](pre + e.type, init, false);
      if (!done && (done = true)) {
        return fn.call(win, e.type || e);
      }
    };
    poll = function() {
      var e;
      try {
        root.doScroll("left");
      } catch (_error) {
        e = _error;
        setTimeout(poll, 50);
        return;
      }
      return init("poll");
    };
    if (doc.readyState !== "complete") {
      if (doc.createEventObject && root.doScroll) {
        try {
          top = !win.frameElement;
        } catch (_error) {}
        if (top) {
          poll();
        }
      }
      doc[add](pre + "DOMContentLoaded", init, false);
      doc[add](pre + "readystatechange", init, false);
      return win[add](pre + "load", init, false);
    }
  };

  Dropzone._autoDiscoverFunction = function() {
    if (Dropzone.autoDiscover) {
      return Dropzone.discover();
    }
  };

  contentLoaded(window, Dropzone._autoDiscoverFunction);

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js"), __webpack_require__("../../../node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "../../../node_modules/visibilityjs/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("../../../node_modules/visibilityjs/lib/visibility.timers.js")


/***/ }),

/***/ "../../../node_modules/visibilityjs/lib/visibility.core.js":
/***/ (function(module, exports) {

;(function (global) {
    "use strict";

    var lastId = -1;

    // Visibility.js allow you to know, that your web page is in the background
    // tab and thus not visible to the user. This library is wrap under
    // Page Visibility API. It fix problems with different vendor prefixes and
    // add high-level useful functions.
    var self = {

        // Call callback only when page become to visible for user or
        // call it now if page is visible now or Page Visibility API
        // doesn’t supported.
        //
        // Return false if API isn’t supported, true if page is already visible
        // or listener ID (you can use it in `unbind` method) if page isn’t
        // visible now.
        //
        //   Visibility.onVisible(function () {
        //       startIntroAnimation();
        //   });
        onVisible: function (callback) {
            var support = self.isSupported();
            if ( !support || !self.hidden() ) {
                callback();
                return support;
            }

            var listener = self.change(function (e, state) {
                if ( !self.hidden() ) {
                    self.unbind(listener);
                    callback();
                }
            });
            return listener;
        },

        // Call callback when visibility will be changed. First argument for
        // callback will be original event object, second will be visibility
        // state name.
        //
        // Return listener ID to unbind listener by `unbind` method.
        //
        // If Page Visibility API doesn’t supported method will be return false
        // and callback never will be called.
        //
        //   Visibility.change(function(e, state) {
        //       Statistics.visibilityChange(state);
        //   });
        //
        // It is just proxy to `visibilitychange` event, but use vendor prefix.
        change: function (callback) {
            if ( !self.isSupported() ) {
                return false;
            }
            lastId += 1;
            var number = lastId;
            self._callbacks[number] = callback;
            self._listen();
            return number;
        },

        // Remove `change` listener by it ID.
        //
        //   var id = Visibility.change(function(e, state) {
        //       firstChangeCallback();
        //       Visibility.unbind(id);
        //   });
        unbind: function (id) {
            delete self._callbacks[id];
        },

        // Call `callback` in any state, expect “prerender”. If current state
        // is “prerender” it will wait until state will be changed.
        // If Page Visibility API doesn’t supported, it will call `callback`
        // immediately.
        //
        // Return false if API isn’t supported, true if page is already after
        // prerendering or listener ID (you can use it in `unbind` method)
        // if page is prerended now.
        //
        //   Visibility.afterPrerendering(function () {
        //       Statistics.countVisitor();
        //   });
        afterPrerendering: function (callback) {
            var support   = self.isSupported();
            var prerender = 'prerender';

            if ( !support || prerender != self.state() ) {
                callback();
                return support;
            }

            var listener = self.change(function (e, state) {
                if ( prerender != state ) {
                    self.unbind(listener);
                    callback();
                }
            });
            return listener;
        },

        // Return true if page now isn’t visible to user.
        //
        //   if ( !Visibility.hidden() ) {
        //       VideoPlayer.play();
        //   }
        //
        // It is just proxy to `document.hidden`, but use vendor prefix.
        hidden: function () {
            return !!(self._doc.hidden || self._doc.webkitHidden);
        },

        // Return visibility state: 'visible', 'hidden' or 'prerender'.
        //
        //   if ( 'prerender' == Visibility.state() ) {
        //       Statistics.pageIsPrerendering();
        //   }
        //
        // Don’t use `Visibility.state()` to detect, is page visible, because
        // visibility states can extend in next API versions.
        // Use more simpler and general `Visibility.hidden()` for this cases.
        //
        // It is just proxy to `document.visibilityState`, but use
        // vendor prefix.
        state: function () {
            return self._doc.visibilityState       ||
                   self._doc.webkitVisibilityState ||
                   'visible';
        },

        // Return true if browser support Page Visibility API.
        //
        //   if ( Visibility.isSupported() ) {
        //       Statistics.startTrackingVisibility();
        //       Visibility.change(function(e, state)) {
        //           Statistics.trackVisibility(state);
        //       });
        //   }
        isSupported: function () {
            return !!(self._doc.visibilityState ||
                      self._doc.webkitVisibilityState);
        },

        // Link to document object to change it in tests.
        _doc: document || {},

        // Callbacks from `change` method, that wait visibility changes.
        _callbacks: { },

        // Listener for `visibilitychange` event.
        _change: function(event) {
            var state = self.state();

            for ( var i in self._callbacks ) {
                self._callbacks[i].call(self._doc, event, state);
            }
        },

        // Set listener for `visibilitychange` event.
        _listen: function () {
            if ( self._init ) {
                return;
            }

            var event = 'visibilitychange';
            if ( self._doc.webkitVisibilityState ) {
                event = 'webkit' + event;
            }

            var listener = function () {
                self._change.apply(self, arguments);
            };
            if ( self._doc.addEventListener ) {
                self._doc.addEventListener(event, listener);
            } else {
                self._doc.attachEvent(event, listener);
            }
            self._init = true;
        }

    };

    if ( typeof(module) != 'undefined' && module.exports ) {
        module.exports = self;
    } else {
        global.Visibility = self;
    }

})(this);


/***/ }),

/***/ "../../../node_modules/visibilityjs/lib/visibility.timers.js":
/***/ (function(module, exports, __webpack_require__) {

;(function (window) {
    "use strict";

    var lastTimer = -1;

    var install = function (Visibility) {

        // Run callback every `interval` milliseconds if page is visible and
        // every `hiddenInterval` milliseconds if page is hidden.
        //
        //   Visibility.every(60 * 1000, 5 * 60 * 1000, function () {
        //       checkNewMails();
        //   });
        //
        // You can skip `hiddenInterval` and callback will be called only if
        // page is visible.
        //
        //   Visibility.every(1000, function () {
        //       updateCountdown();
        //   });
        //
        // It is analog of `setInterval(callback, interval)` but use visibility
        // state.
        //
        // It return timer ID, that you can use in `Visibility.stop(id)` to stop
        // timer (`clearInterval` analog).
        // Warning: timer ID is different from interval ID from `setInterval`,
        // so don’t use it in `clearInterval`.
        //
        // On change state from hidden to visible timers will be execute.
        Visibility.every = function (interval, hiddenInterval, callback) {
            Visibility._time();

            if ( !callback ) {
                callback = hiddenInterval;
                hiddenInterval = null;
            }

            lastTimer += 1;
            var number = lastTimer;

            Visibility._timers[number] = {
                visible:  interval,
                hidden:   hiddenInterval,
                callback: callback
            };
            Visibility._run(number, false);

            if ( Visibility.isSupported() ) {
                Visibility._listen();
            }
            return number;
        };

        // Stop timer from `every` method by it ID (`every` method return it).
        //
        //   slideshow = Visibility.every(5 * 1000, function () {
        //       changeSlide();
        //   });
        //   $('.stopSlideshow').click(function () {
        //       Visibility.stop(slideshow);
        //   });
        Visibility.stop = function(id) {
            if ( !Visibility._timers[id] ) {
                return false;
            }
            Visibility._stop(id);
            delete Visibility._timers[id];
            return true;
        };

        // Callbacks and intervals added by `every` method.
        Visibility._timers = { };

        // Initialize variables on page loading.
        Visibility._time = function () {
            if ( Visibility._timed ) {
                return;
            }
            Visibility._timed     = true;
            Visibility._wasHidden = Visibility.hidden();

            Visibility.change(function () {
                Visibility._stopRun();
                Visibility._wasHidden = Visibility.hidden();
            });
        };

        // Try to run timer from every method by it’s ID. It will be use
        // `interval` or `hiddenInterval` depending on visibility state.
        // If page is hidden and `hiddenInterval` is null,
        // it will not run timer.
        //
        // Argument `runNow` say, that timers must be execute now too.
        Visibility._run = function (id, runNow) {
            var interval,
                timer = Visibility._timers[id];

            if ( Visibility.hidden() ) {
                if ( null === timer.hidden ) {
                    return;
                }
                interval = timer.hidden;
            } else {
                interval = timer.visible;
            }

            var runner = function () {
                timer.last = new Date();
                timer.callback.call(window);
            }

            if ( runNow ) {
                var now  = new Date();
                var last = now - timer.last ;

                if ( interval > last ) {
                    timer.delay = setTimeout(function () {
                        timer.id = setInterval(runner, interval);
                        runner();
                    }, interval - last);
                } else {
                    timer.id = setInterval(runner, interval);
                    runner();
                }

            } else {
              timer.id = setInterval(runner, interval);
            }
        };

        // Stop timer from `every` method by it’s ID.
        Visibility._stop = function (id) {
            var timer = Visibility._timers[id];
            clearInterval(timer.id);
            clearTimeout(timer.delay);
            delete timer.id;
            delete timer.delay;
        };

        // Listener for `visibilitychange` event.
        Visibility._stopRun = function (event) {
            var isHidden  = Visibility.hidden(),
                wasHidden = Visibility._wasHidden;

            if ( (isHidden && !wasHidden) || (!isHidden && wasHidden) ) {
                for ( var i in Visibility._timers ) {
                    Visibility._stop(i);
                    Visibility._run(i, !isHidden);
                }
            }
        };

        return Visibility;
    }

    if ( typeof(module) != 'undefined' && module.exports ) {
        module.exports = install(__webpack_require__("../../../node_modules/visibilityjs/lib/visibility.core.js"));
    } else {
        install(window.Visibility)
    }

})(window);


/***/ }),

/***/ "../../../node_modules/webpack/buildin/module.js":
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "./blob/blob_file_dropzone.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dropzone__ = __webpack_require__("../../../node_modules/dropzone/dist/dropzone.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_url_utility__ = __webpack_require__("./lib/utils/url_utility.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils_constants__ = __webpack_require__("./lib/utils/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_utils_csrf__ = __webpack_require__("./lib/utils/csrf.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable func-names, object-shorthand, prefer-arrow-callback */





__WEBPACK_IMPORTED_MODULE_0_dropzone___default.a.autoDiscover = false;

function toggleLoading($el, $icon, loading) {
  if (loading) {
    $el.disable();
    $icon.removeClass(__WEBPACK_IMPORTED_MODULE_2__lib_utils_constants__["b" /* HIDDEN_CLASS */]);
  } else {
    $el.enable();
    $icon.addClass(__WEBPACK_IMPORTED_MODULE_2__lib_utils_constants__["b" /* HIDDEN_CLASS */]);
  }
}

var BlobFileDropzone = function BlobFileDropzone(form, method) {
  _classCallCheck(this, BlobFileDropzone);

  var formDropzone = form.find('.dropzone');
  var submitButton = form.find('#submit-all');
  var submitButtonLoadingIcon = submitButton.find('.js-loading-icon');
  var dropzoneMessage = form.find('.dz-message');
  __WEBPACK_IMPORTED_MODULE_0_dropzone___default.a.autoDiscover = false;

  var dropzone = formDropzone.dropzone({
    autoDiscover: false,
    autoProcessQueue: false,
    url: form.attr('action'),
    // Rails uses a hidden input field for PUT
    // http://stackoverflow.com/questions/21056482/how-to-set-method-put-in-form-tag-in-rails
    method: method,
    clickable: true,
    uploadMultiple: false,
    paramName: 'file',
    maxFilesize: gon.max_file_size || 10,
    parallelUploads: 1,
    maxFiles: 1,
    addRemoveLinks: true,
    previewsContainer: '.dropzone-previews',
    headers: __WEBPACK_IMPORTED_MODULE_3__lib_utils_csrf__["a" /* default */].headers,
    init: function init() {
      this.on('addedfile', function () {
        toggleLoading(submitButton, submitButtonLoadingIcon, false);
        dropzoneMessage.addClass(__WEBPACK_IMPORTED_MODULE_2__lib_utils_constants__["b" /* HIDDEN_CLASS */]);
        $('.dropzone-alerts').html('').hide();
      });
      this.on('removedfile', function () {
        toggleLoading(submitButton, submitButtonLoadingIcon, false);
        dropzoneMessage.removeClass(__WEBPACK_IMPORTED_MODULE_2__lib_utils_constants__["b" /* HIDDEN_CLASS */]);
      });
      this.on('success', function (header, response) {
        $('#modal-upload-blob').modal('hide');
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils_url_utility__["g" /* visitUrl */])(response.filePath);
      });
      this.on('maxfilesexceeded', function (file) {
        dropzoneMessage.addClass(__WEBPACK_IMPORTED_MODULE_2__lib_utils_constants__["b" /* HIDDEN_CLASS */]);
        this.removeFile(file);
      });
      this.on('sending', function (file, xhr, formData) {
        formData.append('branch_name', form.find('.js-branch-name').val());
        formData.append('create_merge_request', form.find('.js-create-merge-request').val());
        formData.append('commit_message', form.find('.js-commit-message').val());
      });
    },
    // Override behavior of adding error underneath preview
    error: function error(file, errorMessage) {
      var stripped = $('<div/>').html(errorMessage).text();
      $('.dropzone-alerts').html('Error uploading file: "' + stripped + '"').show();
      this.removeFile(file);
    }
  });

  submitButton.on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (dropzone[0].dropzone.getQueuedFiles().length === 0) {
      // eslint-disable-next-line no-alert
      alert('Please select a file');
      return false;
    }
    toggleLoading(submitButton, submitButtonLoadingIcon, true);
    dropzone[0].dropzone.processQueue();
    return false;
  });
};

/* harmony default export */ __webpack_exports__["a"] = (BlobFileDropzone);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./blob/file_template_mediator.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__template_selectors_type_selector__ = __webpack_require__("./blob/template_selectors/type_selector.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__template_selectors_ci_yaml_selector__ = __webpack_require__("./blob/template_selectors/ci_yaml_selector.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__template_selectors_dockerfile_selector__ = __webpack_require__("./blob/template_selectors/dockerfile_selector.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__template_selectors_gitignore_selector__ = __webpack_require__("./blob/template_selectors/gitignore_selector.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__template_selectors_license_selector__ = __webpack_require__("./blob/template_selectors/license_selector.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this */







var FileTemplateMediator = function () {
  function FileTemplateMediator(_ref) {
    var editor = _ref.editor,
        currentAction = _ref.currentAction;

    _classCallCheck(this, FileTemplateMediator);

    this.editor = editor;
    this.currentAction = currentAction;

    this.initTemplateSelectors();
    this.initTemplateTypeSelector();
    this.initDomElements();
    this.initDropdowns();
    this.initPageEvents();
  }

  _createClass(FileTemplateMediator, [{
    key: 'initTemplateSelectors',
    value: function initTemplateSelectors() {
      var _this = this;

      // Order dictates template type dropdown item order
      this.templateSelectors = [__WEBPACK_IMPORTED_MODULE_4__template_selectors_gitignore_selector__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__template_selectors_ci_yaml_selector__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__template_selectors_dockerfile_selector__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__template_selectors_license_selector__["a" /* default */]].map(function (TemplateSelectorClass) {
        return new TemplateSelectorClass({ mediator: _this });
      });
    }
  }, {
    key: 'initTemplateTypeSelector',
    value: function initTemplateTypeSelector() {
      this.typeSelector = new __WEBPACK_IMPORTED_MODULE_1__template_selectors_type_selector__["a" /* default */]({
        mediator: this,
        dropdownData: this.templateSelectors.map(function (templateSelector) {
          var cfg = templateSelector.config;

          return {
            name: cfg.name,
            key: cfg.key
          };
        })
      });
    }
  }, {
    key: 'initDomElements',
    value: function initDomElements() {
      var $templatesMenu = $('.template-selectors-menu');
      var $undoMenu = $templatesMenu.find('.template-selectors-undo-menu');
      var $fileEditor = $('.file-editor');

      this.$templatesMenu = $templatesMenu;
      this.$undoMenu = $undoMenu;
      this.$undoBtn = $undoMenu.find('button');
      this.$templateSelectors = $templatesMenu.find('.template-selector-dropdowns-wrap');
      this.$filenameInput = $fileEditor.find('.js-file-path-name-input');
      this.$fileContent = $fileEditor.find('#file-content');
      this.$commitForm = $fileEditor.find('form');
      this.$navLinks = $fileEditor.find('.nav-links');
    }
  }, {
    key: 'initDropdowns',
    value: function initDropdowns() {
      if (this.currentAction === 'create') {
        this.typeSelector.show();
      } else {
        this.hideTemplateSelectorMenu();
      }

      this.displayMatchedTemplateSelector();
    }
  }, {
    key: 'initPageEvents',
    value: function initPageEvents() {
      this.listenForFilenameInput();
      this.prepFileContentForSubmit();
      this.listenForPreviewMode();
    }
  }, {
    key: 'listenForFilenameInput',
    value: function listenForFilenameInput() {
      var _this2 = this;

      this.$filenameInput.on('keyup blur', function () {
        _this2.displayMatchedTemplateSelector();
      });
    }
  }, {
    key: 'prepFileContentForSubmit',
    value: function prepFileContentForSubmit() {
      var _this3 = this;

      this.$commitForm.submit(function () {
        _this3.$fileContent.val(_this3.editor.getValue());
      });
    }
  }, {
    key: 'listenForPreviewMode',
    value: function listenForPreviewMode() {
      var _this4 = this;

      this.$navLinks.on('click', 'a', function (e) {
        var urlPieces = e.target.href.split('#');
        var hash = urlPieces[1];
        if (hash === 'preview') {
          _this4.hideTemplateSelectorMenu();
        } else if (hash === 'editor') {
          _this4.showTemplateSelectorMenu();
        }
      });
    }
  }, {
    key: 'selectTemplateType',
    value: function selectTemplateType(item, e) {
      if (e) {
        e.preventDefault();
      }

      this.templateSelectors.forEach(function (selector) {
        if (selector.config.key === item.key) {
          selector.show();
        } else {
          selector.hide();
        }
      });

      this.typeSelector.setToggleText(item.name);

      this.cacheToggleText();
    }
  }, {
    key: 'selectTemplateTypeOptions',
    value: function selectTemplateTypeOptions(options) {
      this.selectTemplateType(options.selectedObj, options.e);
    }
  }, {
    key: 'selectTemplateFile',
    value: function selectTemplateFile(selector, query, data) {
      var _this5 = this;

      selector.renderLoading();
      // in case undo menu is already already there
      this.destroyUndoMenu();
      this.fetchFileTemplate(selector.config.endpoint, query, data).then(function (file) {
        _this5.showUndoMenu();
        _this5.setEditorContent(file);
        _this5.setFilename(selector.config.name);
        selector.renderLoaded();
      }).catch(function (err) {
        return new __WEBPACK_IMPORTED_MODULE_0__flash__["a" /* default */]('An error occurred while fetching the template: ' + err);
      });
    }
  }, {
    key: 'displayMatchedTemplateSelector',
    value: function displayMatchedTemplateSelector() {
      var _this6 = this;

      var currentInput = this.getFilename();
      this.templateSelectors.forEach(function (selector) {
        var match = selector.config.pattern.test(currentInput);

        if (match) {
          _this6.typeSelector.show();
          _this6.selectTemplateType(selector.config);
          _this6.showTemplateSelectorMenu();
        }
      });
    }
  }, {
    key: 'fetchFileTemplate',
    value: function fetchFileTemplate(apiCall, query, data) {
      return new Promise(function (resolve) {
        var resolveFile = function resolveFile(file) {
          return resolve(file);
        };

        if (!data) {
          apiCall(query, resolveFile);
        } else {
          apiCall(query, data, resolveFile);
        }
      });
    }
  }, {
    key: 'setEditorContent',
    value: function setEditorContent(file) {
      if (!file && file !== '') return;

      var newValue = file.content || file;

      this.editor.setValue(newValue, 1);

      this.editor.focus();

      this.editor.navigateFileStart();
    }
  }, {
    key: 'findTemplateSelectorByKey',
    value: function findTemplateSelectorByKey(key) {
      return this.templateSelectors.find(function (selector) {
        return selector.config.key === key;
      });
    }
  }, {
    key: 'showUndoMenu',
    value: function showUndoMenu() {
      var _this7 = this;

      this.$undoMenu.removeClass('hidden');

      this.$undoBtn.on('click', function () {
        _this7.restoreFromCache();
        _this7.destroyUndoMenu();
      });
    }
  }, {
    key: 'destroyUndoMenu',
    value: function destroyUndoMenu() {
      this.cacheFileContents();
      this.cacheToggleText();
      this.$undoMenu.addClass('hidden');
      this.$undoBtn.off('click');
    }
  }, {
    key: 'hideTemplateSelectorMenu',
    value: function hideTemplateSelectorMenu() {
      this.$templatesMenu.hide();
    }
  }, {
    key: 'showTemplateSelectorMenu',
    value: function showTemplateSelectorMenu() {
      this.$templatesMenu.show();
    }
  }, {
    key: 'cacheToggleText',
    value: function cacheToggleText() {
      this.cachedToggleText = this.getTemplateSelectorToggleText();
    }
  }, {
    key: 'cacheFileContents',
    value: function cacheFileContents() {
      this.cachedContent = this.editor.getValue();
      this.cachedFilename = this.getFilename();
    }
  }, {
    key: 'restoreFromCache',
    value: function restoreFromCache() {
      this.setEditorContent(this.cachedContent);
      this.setFilename(this.cachedFilename);
      this.setTemplateSelectorToggleText();
    }
  }, {
    key: 'getTemplateSelectorToggleText',
    value: function getTemplateSelectorToggleText() {
      return this.$templateSelectors.find('.js-template-selector-wrap:visible .dropdown-toggle-text').text();
    }
  }, {
    key: 'setTemplateSelectorToggleText',
    value: function setTemplateSelectorToggleText() {
      return this.$templateSelectors.find('.js-template-selector-wrap:visible .dropdown-toggle-text').text(this.cachedToggleText);
    }
  }, {
    key: 'getTypeSelectorToggleText',
    value: function getTypeSelectorToggleText() {
      return this.typeSelector.getToggleText();
    }
  }, {
    key: 'getFilename',
    value: function getFilename() {
      return this.$filenameInput.val();
    }
  }, {
    key: 'setFilename',
    value: function setFilename(name) {
      this.$filenameInput.val(name).trigger('change');
    }
  }, {
    key: 'getSelected',
    value: function getSelected() {
      return this.templateSelectors.find(function (selector) {
        return selector.selected;
      });
    }
  }]);

  return FileTemplateMediator;
}();

/* harmony default export */ __webpack_exports__["a"] = (FileTemplateMediator);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./blob/file_template_selector.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FileTemplateSelector = function () {
  function FileTemplateSelector(mediator) {
    _classCallCheck(this, FileTemplateSelector);

    this.mediator = mediator;
    this.$dropdown = null;
    this.$wrapper = null;
  }

  _createClass(FileTemplateSelector, [{
    key: 'init',
    value: function init() {
      var cfg = this.config;

      this.$dropdown = $(cfg.dropdown);
      this.$wrapper = $(cfg.wrapper);
      this.$loadingIcon = this.$wrapper.find('.fa-chevron-down');
      this.$dropdownToggleText = this.$wrapper.find('.dropdown-toggle-text');

      this.initDropdown();
    }
  }, {
    key: 'show',
    value: function show() {
      if (this.$dropdown === null) {
        this.init();
      }

      this.$wrapper.removeClass('hidden');
    }
  }, {
    key: 'hide',
    value: function hide() {
      if (this.$dropdown !== null) {
        this.$wrapper.addClass('hidden');
      }
    }
  }, {
    key: 'getToggleText',
    value: function getToggleText() {
      return this.$dropdownToggleText.text();
    }
  }, {
    key: 'setToggleText',
    value: function setToggleText(text) {
      this.$dropdownToggleText.text(text);
    }
  }, {
    key: 'renderLoading',
    value: function renderLoading() {
      this.$loadingIcon.addClass('fa-spinner fa-spin').removeClass('fa-chevron-down');
    }
  }, {
    key: 'renderLoaded',
    value: function renderLoaded() {
      this.$loadingIcon.addClass('fa-chevron-down').removeClass('fa-spinner fa-spin');
    }
  }, {
    key: 'reportSelection',
    value: function reportSelection(options) {
      var query = options.query,
          e = options.e,
          data = options.data;

      e.preventDefault();
      return this.mediator.selectTemplateFile(this, query, data);
    }
  }, {
    key: 'reportSelectionName',
    value: function reportSelectionName(options) {
      var opts = options;
      opts.query = options.selectedObj.name;

      this.reportSelection(opts);
    }
  }]);

  return FileTemplateSelector;
}();

/* harmony default export */ __webpack_exports__["a"] = (FileTemplateSelector);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./blob/template_selectors/ci_yaml_selector.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("./api.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__file_template_selector__ = __webpack_require__("./blob/file_template_selector.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var BlobCiYamlSelector = function (_FileTemplateSelector) {
  _inherits(BlobCiYamlSelector, _FileTemplateSelector);

  function BlobCiYamlSelector(_ref) {
    var mediator = _ref.mediator;

    _classCallCheck(this, BlobCiYamlSelector);

    var _this = _possibleConstructorReturn(this, (BlobCiYamlSelector.__proto__ || Object.getPrototypeOf(BlobCiYamlSelector)).call(this, mediator));

    _this.config = {
      key: 'gitlab-ci-yaml',
      name: '.gitlab-ci.yml',
      pattern: /(.gitlab-ci.yml)/,
      endpoint: __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].gitlabCiYml,
      dropdown: '.js-gitlab-ci-yml-selector',
      wrapper: '.js-gitlab-ci-yml-selector-wrap'
    };
    return _this;
  }

  _createClass(BlobCiYamlSelector, [{
    key: 'initDropdown',
    value: function initDropdown() {
      var _this2 = this;

      // maybe move to super class as well
      this.$dropdown.glDropdown({
        data: this.$dropdown.data('data'),
        filterable: true,
        selectable: true,
        toggleLabel: function toggleLabel(item) {
          return item.name;
        },
        search: {
          fields: ['name']
        },
        clicked: function clicked(options) {
          return _this2.reportSelectionName(options);
        },
        text: function text(item) {
          return item.name;
        }
      });
    }
  }]);

  return BlobCiYamlSelector;
}(__WEBPACK_IMPORTED_MODULE_1__file_template_selector__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (BlobCiYamlSelector);

/***/ }),

/***/ "./blob/template_selectors/dockerfile_selector.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("./api.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__file_template_selector__ = __webpack_require__("./blob/file_template_selector.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var DockerfileSelector = function (_FileTemplateSelector) {
  _inherits(DockerfileSelector, _FileTemplateSelector);

  function DockerfileSelector(_ref) {
    var mediator = _ref.mediator;

    _classCallCheck(this, DockerfileSelector);

    var _this = _possibleConstructorReturn(this, (DockerfileSelector.__proto__ || Object.getPrototypeOf(DockerfileSelector)).call(this, mediator));

    _this.config = {
      key: 'dockerfile',
      name: 'Dockerfile',
      pattern: /(Dockerfile)/,
      endpoint: __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].dockerfileYml,
      dropdown: '.js-dockerfile-selector',
      wrapper: '.js-dockerfile-selector-wrap'
    };
    return _this;
  }

  _createClass(DockerfileSelector, [{
    key: 'initDropdown',
    value: function initDropdown() {
      var _this2 = this;

      // maybe move to super class as well
      this.$dropdown.glDropdown({
        data: this.$dropdown.data('data'),
        filterable: true,
        selectable: true,
        toggleLabel: function toggleLabel(item) {
          return item.name;
        },
        search: {
          fields: ['name']
        },
        clicked: function clicked(options) {
          return _this2.reportSelectionName(options);
        },
        text: function text(item) {
          return item.name;
        }
      });
    }
  }]);

  return DockerfileSelector;
}(__WEBPACK_IMPORTED_MODULE_1__file_template_selector__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (DockerfileSelector);

/***/ }),

/***/ "./blob/template_selectors/gitignore_selector.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("./api.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__file_template_selector__ = __webpack_require__("./blob/file_template_selector.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var BlobGitignoreSelector = function (_FileTemplateSelector) {
  _inherits(BlobGitignoreSelector, _FileTemplateSelector);

  function BlobGitignoreSelector(_ref) {
    var mediator = _ref.mediator;

    _classCallCheck(this, BlobGitignoreSelector);

    var _this = _possibleConstructorReturn(this, (BlobGitignoreSelector.__proto__ || Object.getPrototypeOf(BlobGitignoreSelector)).call(this, mediator));

    _this.config = {
      key: 'gitignore',
      name: '.gitignore',
      pattern: /(.gitignore)/,
      endpoint: __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].gitignoreText,
      dropdown: '.js-gitignore-selector',
      wrapper: '.js-gitignore-selector-wrap'
    };
    return _this;
  }

  _createClass(BlobGitignoreSelector, [{
    key: 'initDropdown',
    value: function initDropdown() {
      var _this2 = this;

      this.$dropdown.glDropdown({
        data: this.$dropdown.data('data'),
        filterable: true,
        selectable: true,
        toggleLabel: function toggleLabel(item) {
          return item.name;
        },
        search: {
          fields: ['name']
        },
        clicked: function clicked(options) {
          return _this2.reportSelectionName(options);
        },
        text: function text(item) {
          return item.name;
        }
      });
    }
  }]);

  return BlobGitignoreSelector;
}(__WEBPACK_IMPORTED_MODULE_1__file_template_selector__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (BlobGitignoreSelector);

/***/ }),

/***/ "./blob/template_selectors/license_selector.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("./api.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__file_template_selector__ = __webpack_require__("./blob/file_template_selector.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var BlobLicenseSelector = function (_FileTemplateSelector) {
  _inherits(BlobLicenseSelector, _FileTemplateSelector);

  function BlobLicenseSelector(_ref) {
    var mediator = _ref.mediator;

    _classCallCheck(this, BlobLicenseSelector);

    var _this = _possibleConstructorReturn(this, (BlobLicenseSelector.__proto__ || Object.getPrototypeOf(BlobLicenseSelector)).call(this, mediator));

    _this.config = {
      key: 'license',
      name: 'LICENSE',
      pattern: /^(.+\/)?(licen[sc]e|copying)($|\.)/i,
      endpoint: __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].licenseText,
      dropdown: '.js-license-selector',
      wrapper: '.js-license-selector-wrap'
    };
    return _this;
  }

  _createClass(BlobLicenseSelector, [{
    key: 'initDropdown',
    value: function initDropdown() {
      var _this2 = this;

      this.$dropdown.glDropdown({
        data: this.$dropdown.data('data'),
        filterable: true,
        selectable: true,
        toggleLabel: function toggleLabel(item) {
          return item.name;
        },
        search: {
          fields: ['name']
        },
        clicked: function clicked(options) {
          var e = options.e;

          var el = options.$el;
          var query = options.selectedObj;

          var data = {
            project: _this2.$dropdown.data('project'),
            fullname: _this2.$dropdown.data('fullname')
          };

          _this2.reportSelection({
            query: query.id,
            el: el,
            e: e,
            data: data
          });
        },
        text: function text(item) {
          return item.name;
        }
      });
    }
  }]);

  return BlobLicenseSelector;
}(__WEBPACK_IMPORTED_MODULE_1__file_template_selector__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (BlobLicenseSelector);

/***/ }),

/***/ "./blob/template_selectors/type_selector.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__file_template_selector__ = __webpack_require__("./blob/file_template_selector.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var FileTemplateTypeSelector = function (_FileTemplateSelector) {
  _inherits(FileTemplateTypeSelector, _FileTemplateSelector);

  function FileTemplateTypeSelector(_ref) {
    var mediator = _ref.mediator,
        dropdownData = _ref.dropdownData;

    _classCallCheck(this, FileTemplateTypeSelector);

    var _this = _possibleConstructorReturn(this, (FileTemplateTypeSelector.__proto__ || Object.getPrototypeOf(FileTemplateTypeSelector)).call(this, mediator));

    _this.mediator = mediator;
    _this.config = {
      dropdown: '.js-template-type-selector',
      wrapper: '.js-template-type-selector-wrap',
      dropdownData: dropdownData
    };
    return _this;
  }

  _createClass(FileTemplateTypeSelector, [{
    key: 'initDropdown',
    value: function initDropdown() {
      var _this2 = this;

      this.$dropdown.glDropdown({
        data: this.config.dropdownData,
        filterable: false,
        selectable: true,
        toggleLabel: function toggleLabel(item) {
          return item.name;
        },
        clicked: function clicked(options) {
          return _this2.mediator.selectTemplateTypeOptions(options);
        },
        text: function text(item) {
          return item.name;
        }
      });
    }
  }]);

  return FileTemplateTypeSelector;
}(__WEBPACK_IMPORTED_MODULE_0__file_template_selector__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (FileTemplateTypeSelector);

/***/ }),

/***/ "./blob/viewer/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_common_utils__ = __webpack_require__("./lib/utils/common_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var BlobViewer = function () {
  function BlobViewer() {
    _classCallCheck(this, BlobViewer);

    BlobViewer.initAuxiliaryViewer();
    BlobViewer.initRichViewer();

    this.initMainViewers();
  }

  _createClass(BlobViewer, [{
    key: 'initMainViewers',
    value: function initMainViewers() {
      this.$fileHolder = $('.file-holder');
      if (!this.$fileHolder.length) return;

      this.switcher = document.querySelector('.js-blob-viewer-switcher');
      this.switcherBtns = document.querySelectorAll('.js-blob-viewer-switch-btn');
      this.copySourceBtn = document.querySelector('.js-copy-blob-source-btn');

      this.simpleViewer = this.$fileHolder[0].querySelector('.blob-viewer[data-type="simple"]');
      this.richViewer = this.$fileHolder[0].querySelector('.blob-viewer[data-type="rich"]');

      this.initBindings();

      this.switchToInitialViewer();
    }
  }, {
    key: 'switchToInitialViewer',
    value: function switchToInitialViewer() {
      var initialViewer = this.$fileHolder[0].querySelector('.blob-viewer:not(.hidden)');
      var initialViewerName = initialViewer.getAttribute('data-type');

      if (this.switcher && location.hash.indexOf('#L') === 0) {
        initialViewerName = 'simple';
      }

      this.switchToViewer(initialViewerName);
    }
  }, {
    key: 'initBindings',
    value: function initBindings() {
      var _this = this;

      if (this.switcherBtns.length) {
        Array.from(this.switcherBtns).forEach(function (el) {
          el.addEventListener('click', _this.switchViewHandler.bind(_this));
        });
      }

      if (this.copySourceBtn) {
        this.copySourceBtn.addEventListener('click', function () {
          if (_this.copySourceBtn.classList.contains('disabled')) return _this.copySourceBtn.blur();

          return _this.switchToViewer('simple');
        });
      }
    }
  }, {
    key: 'switchViewHandler',
    value: function switchViewHandler(e) {
      var target = e.currentTarget;

      e.preventDefault();

      this.switchToViewer(target.getAttribute('data-viewer'));
    }
  }, {
    key: 'toggleCopyButtonState',
    value: function toggleCopyButtonState() {
      if (!this.copySourceBtn) return;

      if (this.simpleViewer.getAttribute('data-loaded')) {
        this.copySourceBtn.setAttribute('title', 'Copy source to clipboard');
        this.copySourceBtn.classList.remove('disabled');
      } else if (this.activeViewer === this.simpleViewer) {
        this.copySourceBtn.setAttribute('title', 'Wait for the source to load to copy it to the clipboard');
        this.copySourceBtn.classList.add('disabled');
      } else {
        this.copySourceBtn.setAttribute('title', 'Switch to the source to copy it to the clipboard');
        this.copySourceBtn.classList.add('disabled');
      }

      $(this.copySourceBtn).tooltip('fixTitle');
    }
  }, {
    key: 'switchToViewer',
    value: function switchToViewer(name) {
      var _this2 = this;

      var newViewer = this.$fileHolder[0].querySelector('.blob-viewer[data-type=\'' + name + '\']');
      if (this.activeViewer === newViewer) return;

      var oldButton = document.querySelector('.js-blob-viewer-switch-btn.active');
      var newButton = document.querySelector('.js-blob-viewer-switch-btn[data-viewer=\'' + name + '\']');
      var oldViewer = this.$fileHolder[0].querySelector('.blob-viewer:not([data-type=\'' + name + '\'])');

      if (oldButton) {
        oldButton.classList.remove('active');
      }

      if (newButton) {
        newButton.classList.add('active');
        newButton.blur();
      }

      if (oldViewer) {
        oldViewer.classList.add('hidden');
      }

      newViewer.classList.remove('hidden');

      this.activeViewer = newViewer;

      this.toggleCopyButtonState();

      BlobViewer.loadViewer(newViewer).then(function (viewer) {
        $(viewer).renderGFM();

        _this2.$fileHolder.trigger('highlight:line');
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils_common_utils__["m" /* handleLocationHash */])();

        _this2.toggleCopyButtonState();
      }).catch(function () {
        return new __WEBPACK_IMPORTED_MODULE_0__flash__["a" /* default */]('Error loading viewer');
      });
    }
  }], [{
    key: 'initAuxiliaryViewer',
    value: function initAuxiliaryViewer() {
      var auxiliaryViewer = document.querySelector('.blob-viewer[data-type="auxiliary"]');
      if (!auxiliaryViewer) return;

      BlobViewer.loadViewer(auxiliaryViewer);
    }
  }, {
    key: 'initRichViewer',
    value: function initRichViewer() {
      var viewer = document.querySelector('.blob-viewer[data-type="rich"]');
      if (!viewer || !viewer.dataset.richType) return;

      var initViewer = function initViewer(promise) {
        return promise.then(function (module) {
          return module.default(viewer);
        }).catch(function (error) {
          Object(__WEBPACK_IMPORTED_MODULE_0__flash__["a" /* default */])('Error loading file viewer.');
          throw error;
        });
      };

      switch (viewer.dataset.richType) {
        case 'balsamiq':
          initViewer(__webpack_require__.e/* import() */("balsamiq_viewer").then(__webpack_require__.bind(null, "./blob/balsamiq_viewer.js")));
          break;
        case 'notebook':
          initViewer(__webpack_require__.e/* import() */("notebook_viewer").then(__webpack_require__.bind(null, "./blob/notebook_viewer.js")));
          break;
        case 'pdf':
          initViewer(__webpack_require__.e/* import() */("pdf_viewer").then(__webpack_require__.bind(null, "./blob/pdf_viewer.js")));
          break;
        case 'sketch':
          initViewer(__webpack_require__.e/* import() */("sketch_viewer").then(__webpack_require__.bind(null, "./blob/sketch_viewer.js")));
          break;
        case 'stl':
          initViewer(__webpack_require__.e/* import() */("stl_viewer").then(__webpack_require__.bind(null, "./blob/stl_viewer.js")));
          break;
        default:
          break;
      }
    }
  }, {
    key: 'loadViewer',
    value: function loadViewer(viewerParam) {
      var viewer = viewerParam;
      var url = viewer.getAttribute('data-url');

      if (!url || viewer.getAttribute('data-loaded') || viewer.getAttribute('data-loading')) {
        return Promise.resolve(viewer);
      }

      viewer.setAttribute('data-loading', 'true');

      return __WEBPACK_IMPORTED_MODULE_2__lib_utils_axios_utils__["a" /* default */].get(url).then(function (_ref) {
        var data = _ref.data;

        viewer.innerHTML = data.html;
        viewer.setAttribute('data-loaded', 'true');

        return viewer;
      });
    }
  }]);

  return BlobViewer;
}();

/* harmony default export */ __webpack_exports__["a"] = (BlobViewer);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./blob_edit/blob_bundle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__new_commit_form__ = __webpack_require__("./new_commit_form.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__edit_blob__ = __webpack_require__("./blob_edit/edit_blob.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__blob_blob_file_dropzone__ = __webpack_require__("./blob/blob_file_dropzone.js");
/* eslint-disable func-names, space-before-function-paren, prefer-arrow-callback, no-var, quotes, vars-on-top, no-unused-vars, no-new, max-len */
/* global EditBlob */




/* harmony default export */ __webpack_exports__["a"] = (function () {
  var editBlobForm = $('.js-edit-blob-form');
  var uploadBlobForm = $('.js-upload-blob-form');
  var deleteBlobForm = $('.js-delete-blob-form');

  if (editBlobForm.length) {
    var urlRoot = editBlobForm.data('relativeUrlRoot');
    var assetsPath = editBlobForm.data('assetsPrefix');
    var blobLanguage = editBlobForm.data('blobLanguage');
    var currentAction = $('.js-file-title').data('currentAction');

    new __WEBPACK_IMPORTED_MODULE_1__edit_blob__["a" /* default */]('' + urlRoot + assetsPath, blobLanguage, currentAction);
    new __WEBPACK_IMPORTED_MODULE_0__new_commit_form__["a" /* default */](editBlobForm);
  }

  if (uploadBlobForm.length) {
    var method = uploadBlobForm.data('method');

    new __WEBPACK_IMPORTED_MODULE_2__blob_blob_file_dropzone__["a" /* default */](uploadBlobForm, method);
    new __WEBPACK_IMPORTED_MODULE_0__new_commit_form__["a" /* default */](uploadBlobForm);

    window.gl.utils.disableButtonIfEmptyField(uploadBlobForm.find('.js-commit-message'), '.btn-upload-file');
  }

  if (deleteBlobForm.length) {
    new __WEBPACK_IMPORTED_MODULE_0__new_commit_form__["a" /* default */](deleteBlobForm);
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./blob_edit/edit_blob.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__locale__ = __webpack_require__("./locale/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__blob_file_template_mediator__ = __webpack_require__("./blob/file_template_mediator.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global ace */






var EditBlob = function () {
  function EditBlob(assetsPath, aceMode, currentAction) {
    _classCallCheck(this, EditBlob);

    this.configureAceEditor(aceMode, assetsPath);
    this.initModePanesAndLinks();
    this.initSoftWrap();
    this.initFileSelectors(currentAction);
  }

  _createClass(EditBlob, [{
    key: 'configureAceEditor',
    value: function configureAceEditor(aceMode, assetsPath) {
      ace.config.set('modePath', assetsPath + '/ace');
      ace.config.loadModule('ace/ext/searchbox');

      this.editor = ace.edit('editor');

      // This prevents warnings re: automatic scrolling being logged
      this.editor.$blockScrolling = Infinity;

      this.editor.focus();

      if (aceMode) {
        this.editor.getSession().setMode('ace/mode/' + aceMode);
      }
    }
  }, {
    key: 'initFileSelectors',
    value: function initFileSelectors(currentAction) {
      this.fileTemplateMediator = new __WEBPACK_IMPORTED_MODULE_3__blob_file_template_mediator__["a" /* default */]({
        currentAction: currentAction,
        editor: this.editor
      });
    }
  }, {
    key: 'initModePanesAndLinks',
    value: function initModePanesAndLinks() {
      var _this = this;

      this.$editModePanes = $('.js-edit-mode-pane');
      this.$editModeLinks = $('.js-edit-mode a');
      this.$editModeLinks.on('click', function (e) {
        return _this.editModeLinkClickHandler(e);
      });
    }
  }, {
    key: 'editModeLinkClickHandler',
    value: function editModeLinkClickHandler(e) {
      e.preventDefault();

      var currentLink = $(e.target);
      var paneId = currentLink.attr('href');
      var currentPane = this.$editModePanes.filter(paneId);

      this.$editModeLinks.parent().removeClass('active hover');

      currentLink.parent().addClass('active hover');

      this.$editModePanes.hide();

      currentPane.fadeIn(200);

      if (paneId === '#preview') {
        this.$toggleButton.hide();
        __WEBPACK_IMPORTED_MODULE_0__lib_utils_axios_utils__["a" /* default */].post(currentLink.data('previewUrl'), {
          content: this.editor.getValue()
        }).then(function (_ref) {
          var data = _ref.data;

          currentPane.empty().append(data);
          currentPane.renderGFM();
        }).catch(function () {
          return Object(__WEBPACK_IMPORTED_MODULE_1__flash__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__locale__["a" /* __ */])('An error occurred previewing the blob'));
        });
      }

      this.$toggleButton.show();

      return this.editor.focus();
    }
  }, {
    key: 'initSoftWrap',
    value: function initSoftWrap() {
      var _this2 = this;

      this.isSoftWrapped = false;
      this.$toggleButton = $('.soft-wrap-toggle');
      this.$toggleButton.on('click', function () {
        return _this2.toggleSoftWrap();
      });
    }
  }, {
    key: 'toggleSoftWrap',
    value: function toggleSoftWrap() {
      this.isSoftWrapped = !this.isSoftWrapped;
      this.$toggleButton.toggleClass('soft-wrap-active', this.isSoftWrapped);
      this.editor.getSession().setUseWrapMode(this.isSoftWrapped);
    }
  }]);

  return EditBlob;
}();

/* harmony default export */ __webpack_exports__["a"] = (EditBlob);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./lib/utils/constants.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BYTES_IN_KIB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HIDDEN_CLASS; });
var BYTES_IN_KIB = 1024;
var HIDDEN_CLASS = 'hidden';

/***/ }),

/***/ "./lib/utils/http_status.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * exports HTTP status codes
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  ABORTED: 0,
  NO_CONTENT: 204,
  OK: 200,
  MULTIPLE_CHOICES: 300,
  BAD_REQUEST: 400
});

/***/ }),

/***/ "./lib/utils/poll.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http_status__ = __webpack_require__("./lib/utils/http_status.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_utils__ = __webpack_require__("./lib/utils/common_utils.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




/**
 * Polling utility for handling realtime updates.
 * Requirements: Promise based HTTP client
 *
 * Service for promise based http client and method need to be provided as props
 *
 * @example
 * new Poll({
 *   resource: resource,
 *   method: 'name',
 *   data: {page: 1, scope: 'all'}, // optional
 *   successCallback: () => {},
 *   errorCallback: () => {},
 *   notificationCallback: () => {}, // optional
 * }).makeRequest();
 *
 * Usage in pipelines table with visibility lib:
 *
 * const poll = new Poll({
 *  resource: this.service,
 *  method: 'getPipelines',
 *  data: { page: pageNumber, scope },
 *  successCallback: this.successCallback,
 *  errorCallback: this.errorCallback,
 *  notificationCallback: this.updateLoading,
 * });
 *
 * if (!Visibility.hidden()) {
 *  poll.makeRequest();
 *  }
 *
 * Visibility.change(() => {
 *  if (!Visibility.hidden()) {
 *   poll.restart();
 *  } else {
 *   poll.stop();
 *  }
* });
 *
 * 1. Checks for response and headers before start polling
 * 2. Interval is provided by `Poll-Interval` header.
 * 3. If `Poll-Interval` is -1, we stop polling
 * 4. If HTTP response is 200, we poll.
 * 5. If HTTP response is different from 200, we stop polling.
 *
 */

var Poll = function () {
  function Poll() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Poll);

    this.options = options;
    this.options.data = options.data || {};
    this.options.notificationCallback = options.notificationCallback || function notificationCallback() {};

    this.intervalHeader = 'POLL-INTERVAL';
    this.timeoutID = null;
    this.canPoll = true;
  }

  _createClass(Poll, [{
    key: 'checkConditions',
    value: function checkConditions(response) {
      var _this = this;

      var headers = Object(__WEBPACK_IMPORTED_MODULE_1__common_utils__["x" /* normalizeHeaders */])(response.headers);
      var pollInterval = parseInt(headers[this.intervalHeader], 10);
      if (pollInterval > 0 && response.status === __WEBPACK_IMPORTED_MODULE_0__http_status__["a" /* default */].OK && this.canPoll) {
        this.timeoutID = setTimeout(function () {
          _this.makeRequest();
        }, pollInterval);
      }
      this.options.successCallback(response);
    }
  }, {
    key: 'makeRequest',
    value: function makeRequest() {
      var _this2 = this;

      var _options = this.options,
          resource = _options.resource,
          method = _options.method,
          data = _options.data,
          errorCallback = _options.errorCallback,
          notificationCallback = _options.notificationCallback;

      // It's called everytime a new request is made. Useful to update the status.

      notificationCallback(true);

      return resource[method](data).then(function (response) {
        _this2.checkConditions(response);
        notificationCallback(false);
      }).catch(function (error) {
        notificationCallback(false);
        if (error.status === __WEBPACK_IMPORTED_MODULE_0__http_status__["a" /* default */].ABORTED) {
          return;
        }
        errorCallback(error);
      });
    }

    /**
     * Stops the polling recursive chain
     * and guarantees if the timeout is already running it won't make another request by
     * cancelling the previously established timeout.
     */

  }, {
    key: 'stop',
    value: function stop() {
      this.canPoll = false;
      clearTimeout(this.timeoutID);
    }

    /**
     * Restarts polling after it has been stoped
     */

  }, {
    key: 'restart',
    value: function restart(options) {
      // update data
      if (options && options.data) {
        this.options.data = options.data;
      }

      this.canPoll = true;
      this.makeRequest();
    }
  }]);

  return Poll;
}();

/* harmony default export */ __webpack_exports__["a"] = (Poll);

/***/ }),

/***/ "./new_commit_form.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, no-return-assign, max-len */
var NewCommitForm = function () {
  function NewCommitForm(form) {
    _classCallCheck(this, NewCommitForm);

    this.form = form;
    this.renderDestination = this.renderDestination.bind(this);
    this.branchName = form.find('.js-branch-name');
    this.originalBranch = form.find('.js-original-branch');
    this.createMergeRequest = form.find('.js-create-merge-request');
    this.createMergeRequestContainer = form.find('.js-create-merge-request-container');
    this.branchName.keyup(this.renderDestination);
    this.renderDestination();
  }

  _createClass(NewCommitForm, [{
    key: 'renderDestination',
    value: function renderDestination() {
      var different;
      different = this.branchName.val() !== this.originalBranch.val();
      if (different) {
        this.createMergeRequestContainer.show();
        if (!this.wasDifferent) {
          this.createMergeRequest.prop('checked', true);
        }
      } else {
        this.createMergeRequestContainer.hide();
        this.createMergeRequest.prop('checked', false);
      }
      return this.wasDifferent = different;
    }
  }]);

  return NewCommitForm;
}();

/* harmony default export */ __webpack_exports__["a"] = (NewCommitForm);

/***/ }),

/***/ "./pages/projects/tree/show/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__blob_edit_blob_bundle__ = __webpack_require__("./blob_edit/blob_bundle.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__projects_tree_components_commit_pipeline_status_component_vue__ = __webpack_require__("./projects/tree/components/commit_pipeline_status_component.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tree__ = __webpack_require__("./tree.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shortcuts_navigation__ = __webpack_require__("./shortcuts_navigation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__blob_viewer__ = __webpack_require__("./blob/viewer/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__new_commit_form__ = __webpack_require__("./new_commit_form.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_utils_common_utils__ = __webpack_require__("./lib/utils/common_utils.js");









document.addEventListener('DOMContentLoaded', function () {
  new __WEBPACK_IMPORTED_MODULE_4__shortcuts_navigation__["a" /* default */](); // eslint-disable-line no-new
  new __WEBPACK_IMPORTED_MODULE_3__tree__["a" /* default */](); // eslint-disable-line no-new
  new __WEBPACK_IMPORTED_MODULE_5__blob_viewer__["a" /* default */](); // eslint-disable-line no-new
  new __WEBPACK_IMPORTED_MODULE_6__new_commit_form__["a" /* default */]($('.js-create-dir-form')); // eslint-disable-line no-new
  $('#tree-slider').waitForImages(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_7__lib_utils_common_utils__["b" /* ajaxGet */])(document.querySelector('.js-tree-content').dataset.logsPath);
  });

  Object(__WEBPACK_IMPORTED_MODULE_1__blob_edit_blob_bundle__["a" /* default */])();
  var commitPipelineStatusEl = document.querySelector('.js-commit-pipeline-status');
  var statusLink = document.querySelector('.commit-actions .ci-status-link');
  if (statusLink != null) {
    statusLink.remove();
    // eslint-disable-next-line no-new
    new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
      el: commitPipelineStatusEl,
      components: {
        commitPipelineStatus: __WEBPACK_IMPORTED_MODULE_2__projects_tree_components_commit_pipeline_status_component_vue__["a" /* default */]
      },
      render: function render(createElement) {
        return createElement('commit-pipeline-status', {
          props: {
            endpoint: commitPipelineStatusEl.dataset.endpoint
          }
        });
      }
    });
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./projects/tree/components/commit_pipeline_status_component.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/visibilityjs/index.js
var visibilityjs = __webpack_require__("../../../node_modules/visibilityjs/index.js");
var visibilityjs_default = /*#__PURE__*/__webpack_require__.n(visibilityjs);

// EXTERNAL MODULE: ./vue_shared/components/ci_icon.vue + 2 modules
var ci_icon = __webpack_require__("./vue_shared/components/ci_icon.vue");

// EXTERNAL MODULE: ./vue_shared/components/loading_icon.vue + 2 modules
var loading_icon = __webpack_require__("./vue_shared/components/loading_icon.vue");

// EXTERNAL MODULE: ./lib/utils/poll.js
var poll = __webpack_require__("./lib/utils/poll.js");

// EXTERNAL MODULE: ./flash.js
var flash = __webpack_require__("./flash.js");

// EXTERNAL MODULE: ./locale/index.js + 1 modules
var locale = __webpack_require__("./locale/index.js");

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// EXTERNAL MODULE: ./lib/utils/axios_utils.js
var axios_utils = __webpack_require__("./lib/utils/axios_utils.js");

// CONCATENATED MODULE: ./projects/tree/services/commit_pipeline_service.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var commit_pipeline_service_CommitPipelineService = function () {
  function CommitPipelineService(endpoint) {
    _classCallCheck(this, CommitPipelineService);

    this.endpoint = endpoint;
  }

  _createClass(CommitPipelineService, [{
    key: 'fetchData',
    value: function fetchData() {
      return axios_utils["a" /* default */].get(this.endpoint);
    }
  }]);

  return CommitPipelineService;
}();

/* harmony default export */ var commit_pipeline_service = (commit_pipeline_service_CommitPipelineService);
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./projects/tree/components/commit_pipeline_status_component.vue










/* harmony default export */ var commit_pipeline_status_component = ({
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  components: {
    ciIcon: ci_icon["a" /* default */],
    loadingIcon: loading_icon["a" /* default */]
  },
  props: {
    endpoint: {
      type: String,
      required: true
    }
    /* This prop can be used to replace some of the `render_commit_status`
    used across GitLab, this way we could use this vue component and add a
    realtime status where it makes sense
    realtime: {
      type: Boolean,
      required: false,
      default: true,
    }, */
  },
  data: function data() {
    return {
      ciStatus: {},
      isLoading: true
    };
  },

  computed: {
    statusTitle: function statusTitle() {
      return Object(locale["f" /* sprintf */])(Object(locale["e" /* s__ */])('Commits|Commit: %{commitText}'), { commitText: this.ciStatus.text });
    }
  },
  mounted: function mounted() {
    this.service = new commit_pipeline_service(this.endpoint);
    this.initPolling();
  },

  methods: {
    successCallback: function successCallback(res) {
      var pipelines = res.data.pipelines;
      if (pipelines.length > 0) {
        // The pipeline entity always keeps the latest pipeline info on the `details.status`
        this.ciStatus = pipelines[0].details.status;
      }
      this.isLoading = false;
    },
    errorCallback: function errorCallback() {
      this.ciStatus = {
        text: 'not found',
        icon: 'status_notfound',
        group: 'notfound'
      };
      this.isLoading = false;
      Object(flash["a" /* default */])(Object(locale["e" /* s__ */])('Something went wrong on our end'));
    },
    initPolling: function initPolling() {
      var _this = this;

      this.poll = new poll["a" /* default */]({
        resource: this.service,
        method: 'fetchData',
        successCallback: function successCallback(response) {
          return _this.successCallback(response);
        },
        errorCallback: this.errorCallback
      });

      if (!visibilityjs_default.a.hidden()) {
        this.isLoading = true;
        this.poll.makeRequest();
      } else {
        this.fetchPipelineCommitData();
      }

      visibilityjs_default.a.change(function () {
        if (!visibilityjs_default.a.hidden()) {
          _this.poll.restart();
        } else {
          _this.poll.stop();
        }
      });
    },
    fetchPipelineCommitData: function fetchPipelineCommitData() {
      this.service.fetchData().then(this.successCallback).catch(this.errorCallback);
    }
  },
  destroy: function destroy() {
    this.poll.stop();
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26b48328","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./projects/tree/components/commit_pipeline_status_component.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoading)?_c('loading-icon',{attrs:{"label":"Loading pipeline status","size":"3"}}):_c('a',{attrs:{"href":_vm.ciStatus.details_path}},[_c('ci-icon',{directives:[{name:"tooltip",rawName:"v-tooltip"}],attrs:{"title":_vm.statusTitle,"aria-label":_vm.statusTitle,"data-container":"body","status":_vm.ciStatus}})],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./projects/tree/components/commit_pipeline_status_component.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  commit_pipeline_status_component,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_commit_pipeline_status_component = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./shortcuts_navigation.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mousetrap__ = __webpack_require__("../../../node_modules/mousetrap/mousetrap.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mousetrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mousetrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__ = __webpack_require__("./shortcuts_dashboard_navigation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shortcuts__ = __webpack_require__("./shortcuts.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var ShortcutsNavigation = function (_Shortcuts) {
  _inherits(ShortcutsNavigation, _Shortcuts);

  function ShortcutsNavigation() {
    _classCallCheck(this, ShortcutsNavigation);

    var _this = _possibleConstructorReturn(this, (ShortcutsNavigation.__proto__ || Object.getPrototypeOf(ShortcutsNavigation)).call(this));

    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g p', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-project');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g e', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-project-activity');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g f', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-tree');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g c', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-commits');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g j', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-builds');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g n', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-network');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g d', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-repository-charts');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g i', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-issues');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g b', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-issue-boards');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g m', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-merge_requests');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g t', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-todos');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g w', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-wiki');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g s', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-snippets');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('i', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-new-issue');
    });

    _this.enabledHelp.push('.hidden-shortcut.project');
    return _this;
  }

  return ShortcutsNavigation;
}(__WEBPACK_IMPORTED_MODULE_2__shortcuts__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ShortcutsNavigation);

/***/ }),

/***/ "./tree.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_url_utility__ = __webpack_require__("./lib/utils/url_utility.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable func-names, space-before-function-paren, wrap-iife, max-len, quotes, consistent-return, no-var, one-var, one-var-declaration-per-line, no-else-return, prefer-arrow-callback, class-methods-use-this */


var TreeView = function () {
  function TreeView() {
    _classCallCheck(this, TreeView);

    this.initKeyNav();
    // Code browser tree slider
    // Make the entire tree-item row clickable, but not if clicking another link (like a commit message)
    $(".tree-content-holder .tree-item").on('click', function (e) {
      var $clickedEl, path;
      $clickedEl = $(e.target);
      path = $('.tree-item-file-name a', this).attr('href');
      if (!$clickedEl.is('a') && !$clickedEl.is('.str-truncated')) {
        if (e.metaKey || e.which === 2) {
          e.preventDefault();
          return window.open(path, '_blank');
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_0__lib_utils_url_utility__["g" /* visitUrl */])(path);
        }
      }
    });
    // Show the "Loading commit data" for only the first element
    $('span.log_loading:first').removeClass('hide');
  }

  _createClass(TreeView, [{
    key: 'initKeyNav',
    value: function initKeyNav() {
      var li, liSelected;
      li = $("tr.tree-item");
      liSelected = null;
      return $('body').keydown(function (e) {
        var next, path;
        if ($("input:focus").length > 0 && (e.which === 38 || e.which === 40)) {
          return false;
        }
        if (e.which === 40) {
          if (liSelected) {
            next = liSelected.next();
            if (next.length > 0) {
              liSelected.removeClass("selected");
              liSelected = next.addClass("selected");
            }
          } else {
            liSelected = li.eq(0).addClass("selected");
          }
          return $(liSelected).focus();
        } else if (e.which === 38) {
          if (liSelected) {
            next = liSelected.prev();
            if (next.length > 0) {
              liSelected.removeClass("selected");
              liSelected = next.addClass("selected");
            }
          } else {
            liSelected = li.last().addClass("selected");
          }
          return $(liSelected).focus();
        } else if (e.which === 13) {
          path = $('.tree-item.selected .tree-item-file-name a').attr('href');
          if (path) {
            return Object(__WEBPACK_IMPORTED_MODULE_0__lib_utils_url_utility__["g" /* visitUrl */])(path);
          }
        }
      });
    }
  }]);

  return TreeView;
}();

/* harmony default export */ __webpack_exports__["a"] = (TreeView);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./vue_shared/components/ci_icon.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./vue_shared/components/icon.vue + 2 modules
var icon = __webpack_require__("./vue_shared/components/icon.vue");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/ci_icon.vue



/**
 * Renders CI icon based on API response shared between all places where it is used.
 *
 * Receives status object containing:
 * status: {
 *   details_path: "/gitlab-org/gitlab-ce/pipelines/8150156" // url
 *   group:"running" // used for CSS class
 *   icon: "icon_status_running" // used to render the icon
 *   label:"running" // used for potential tooltip
 *   text:"running" // text rendered
 * }
 *
 * Used in:
 * - Pipelines table Badge
 * - Pipelines table mini graph
 * - Pipeline graph
 * - Pipeline show view badge
 * - Jobs table
 * - Jobs show view header
 * - Jobs show view sidebar
 */
/* harmony default export */ var ci_icon = ({
  components: {
    icon: icon["a" /* default */]
  },
  props: {
    status: {
      type: Object,
      required: true
    }
  },

  computed: {
    cssClass: function cssClass() {
      var status = this.status.group;
      return 'ci-status-icon ci-status-icon-' + status + ' js-ci-status-icon-' + status;
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36896c14","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/ci_icon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.cssClass},[_c('icon',{attrs:{"name":_vm.status.icon}})],1)}
var staticRenderFns = []

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/ci_icon.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  ci_icon,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_ci_icon = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/icon.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/icon.vue


/* This is a re-usable vue component for rendering a svg sprite
  icon

  Sample configuration:

  <icon
    name="retry"
    :size="32"
    css-classes="top"
  />

*/
// only allow classes in images.scss e.g. s12
var validSizes = [8, 12, 16, 18, 24, 32, 48, 72];

/* harmony default export */ var icon = ({
  props: {
    name: {
      type: String,
      required: true
    },

    size: {
      type: Number,
      required: false,
      default: 16,
      validator: function validator(value) {
        return validSizes.includes(value);
      }
    },

    cssClasses: {
      type: String,
      required: false,
      default: ''
    },

    width: {
      type: Number,
      required: false,
      default: null
    },

    height: {
      type: Number,
      required: false,
      default: null
    },

    y: {
      type: Number,
      required: false,
      default: null
    },

    x: {
      type: Number,
      required: false,
      default: null
    }
  },

  computed: {
    spriteHref: function spriteHref() {
      return gon.sprite_icons + '#' + this.name;
    },
    iconSizeClass: function iconSizeClass() {
      return this.size ? 's' + this.size : '';
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43441268","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/icon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:[_vm.iconSizeClass, _vm.cssClasses],attrs:{"width":_vm.width,"height":_vm.height,"x":_vm.x,"y":_vm.y}},[_c('use',_vm._b({},'use',{ 'xlink:href':_vm.spriteHref },false))])}
var staticRenderFns = []

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/icon.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  icon,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_icon = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/directives/tooltip.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el) {
    $(el).tooltip();
  },
  componentUpdated: function componentUpdated(el) {
    $(el).tooltip('fixTitle');
  },
  unbind: function unbind(el) {
    $(el).tooltip('destroy');
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ })

},["./pages/projects/tree/show/index.js"]);


// WEBPACK FOOTER //
// pages.projects.tree.show.1f352be889c83019b139.bundle.js